<template>
  <div class="bg">
    <headline :params="headLines"></headline>
    <div class="container">
      <div v-show="false" class="test_optimize" @click="removeHighlight">测试标题 清除选区</div>

      <div class="content">
        <article>
          <ul>
            <li class="must title" v-if="!aiEditAuth.includes('intelligentWriting')">
              <input type="text" v-model="global.title" placeholder="输入标题" />

              <span>{{ `${wordNum}/60` }}</span>
              <!-- <span>{{`${(global.title || '').length}/60`}}</span> -->
            </li>
            <li v-else class="must title">
              <p
                class="title_editor"
                :class="{empty:wordNum==0}"
                ref="title_editorRef"
                contenteditable
                @input="handleInputTitle"
                @paste="handlePasteTitle"
                @keydown="handleKeyDownTitle"
                placeholder="输入标题"
                @compositionend="handleCompositionEnd"
                @compositionstart="handleCompositionStart"
              />
              <span>{{ `${wordNum}/60` }}</span>
              <!-- <span>{{`${(global.title || '').length}/60`}}</span> -->
            </li>
            <li class="must depart">
              <div class="between">
                <div>
                  <label>发布部门</label>
                  <div
                    :class="{
                      'select-box': true,
                      disableSelect: !global.depart_edit,
                    }"
                    v-if="global.depart_list"
                  >
                    <span
                      @click.stop="selectUp('depart', '', global.depart_edit)"
                      :class="{
                        down: select.depart.on,
                        notEmpty: select.depart.text,
                      }"
                    >{{ select.depart.text || "请选择部门" }}</span>
                    <dl v-if="select.depart.on == true">
                      <li
                        v-for="(item, index) in global.depart_list"
                        :key="index"
                        @click="selectUp('depart', item, global.depart_edit)"
                        :class="{
                          active: select.depart.id == item.id,
                          lastItem: true,
                        }"
                      >{{ item.title }}</li>
                    </dl>
                  </div>
                </div>

                <div v-show="selectedType.id == 3" class="contentType">
                  <label>内容分类</label>
                  <div
                    v-click-outside="closeContentCategory"
                    :class="{autoSelector: true,on: focusInputing}"
                  >
                    <div @click="focusInputing = true" :class="{contentCategory: true}">
                      <span
                        v-for="(item,index) in content_category_ids"
                        :key="index"
                        class="selectd"
                      >
                        <span>{{item.parentName}}/{{item.name}}</span>
                        <img
                          @click="delContent(item)"
                          class="close"
                          src="@assets/img/interview/del.svg"
                          alt="close"
                        />
                      </span>
                      <p :class="{arrow: true, on: focusInputing}"></p>
                      <!-- <input placeholder="请选择分类" v-model="contentCategoryInput" @input="searchContent()" type="text"> -->
                    </div>
                    <div class="selections" v-show="focusInputing">
                      <p
                        v-show="!item.hide"
                        @click="selectedContent1(item,index1)"
                        v-for="(item,index1) in content_category"
                        :key="index1"
                        :class="{opt: true, on: item.selected}"
                      >
                        <span>{{item.name}}</span>
                        <!-- <img v-if="item.selected" src="@assets/img/interview/select.svg" alt="select"> -->
                      </p>
                    </div>
                    <div class="selections1" v-show="focusInputing&&content_category_index != 999">
                      <p
                        v-show="!item.hide"
                        @click="selectedContent(item,content_category_list.index)"
                        v-for="(item,index1) in content_category[content_category_index]&&content_category[content_category_index].son_list"
                        :key="index1"
                        :class="{opt: true, on: item.selected}"
                      >
                        <span>{{item.name}}</span>
                        <!-- <img v-if="item.selected" src="@assets/img/interview/select.svg" alt="select"> -->
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li v-if="selectedType.id == 3" class="padding18">
              <div class="between">
                <div class="xkleft-container">
                  <xkPicker
                    @picker="isSens"
                    style="margin-right: 25px;"
                    :list="global.is_sensitive"
                    :placeholder="'是否敏感'"
                    :width="130"
                    :must="false"
                    :title="''"
                  ></xkPicker>
                  <xkPicker
                    @picker="isJP"
                    :list="global.is_good"
                    :placeholder="'是否精品'"
                    :width="130"
                    :must="false"
                    :title="''"
                  ></xkPicker>
                </div>
                <div class="xkright-container">
                  <div class="datePicker">
                    <label>日期</label>
                    <div style="width: 318px">
                      <date-picker
                        style="width: 318px"
                        class="xkgcDatepicker"
                        v-model="edit_date"
                        placeholder="请填写日期"
                        calendar-icon="none"
                        :editable="false"
                        :clearable="true"
                        :shortcuts="false"
                        valuetype="format"
                        :format="'YYYY-MM-DD'"
                        confirm
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li v-if="selectedType.id == 3" class="topLine padding18Bottom">
              <div class="between">
                <xkPicker
                  @picker="selectArea"
                  :list="global.field"
                  :placeholder="'请选择领域'"
                  :width="200"
                  :must="false"
                  :title="'领域'"
                ></xkPicker>
                <xkPicker
                  @picker="selectLeader"
                  :list="global.leader"
                  :placeholder="'请选择领导人'"
                  :width="318"
                  :must="false"
                  :title="'领导人'"
                ></xkPicker>
              </div>
            </li>

            <li class="must platform">
              <div class="between">
                <div class="publish-platforms">
                  <label>发布平台</label>
                  <div style="flex: 1;">
                    <div class="platform-selects">
                      <div class="platform-one" v-for="(t, i) in global.column_info || []" :key="i">
                        <span>
                          {{
                          `${t.ftitle}/${t.stitle}${t.ttitle ? "/" : ""}${
                          t.ttitle || ""
                          }`
                          }}
                        </span>
                        <span
                          @click="viewUrl(t.preview_url,t.ftitle)"
                          class="preview"
                          v-show="!!t.preview_url"
                        >
                          <img class="eye" src="@assets/img/index/eye.svg" alt="eye" />
                          预览
                        </span>
                        <!-- <img v-show="global.push_list_edit" src="@assets/img/common/del.svg" alt="del" @click="deletePlatform(t)"> -->
                        <img
                          v-show="global.depart_edit"
                          src="@assets/img/common/del.svg"
                          alt="del"
                          @click="deletePlatform(t)"
                        />
                      </div>
                      <div style="flex: 1;"></div>
                    </div>
                    <!-- <div v-show="global.push_list_edit" class="platform-handle"> -->
                    <div v-show="global.depart_edit" class="platform-handle">
                      <span class="handle" @click="openPublishPlat()">
                        <img src="@assets/img/common/add-green.svg" alt="add" />
                        <span>添加发布的平台</span>
                      </span>
                      <div
                        class="clear"
                        @click="clearPlatforms()"
                        v-if="(global.column_info || []).length > 0"
                      >清空</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li class="must">
          <label>文稿类型</label>
          <p :class="{btn:true, active: item.id === selectedType.id}" v-for="(item, index) in global.type_list" :key="index" @click="draftType(item)">{{item.title}}</p>
            </li>-->
            <!-- <p v-show="selectedType.id == 1" class="warn">警告：红色模版请勿删除！</p> -->
            <div
              :style="{ width: errors.width, top: `${errors.scrollTop}px` }"
              :class="{ errorWrapper: true, fixError: errors.fix }"
            >
              <div :class="{ errors: true }" v-show="errors.list.length > 0">
                <img
                  src="@assets/img/common/close-red.svg"
                  alt="close"
                  class="closeError"
                  @click="errors.list = []"
                />
                <p class="head">
                  <span class="left">
                    <img src="@assets/img/common/warnRed.svg" alt="warn" />
                    <span class="title">检测到错别字</span>
                    <span>（点击文字自动跳转）</span>
                  </span>
                  <span
                    v-if="errors.showToggle"
                    class="right"
                    @click="errors.dexpand = !errors.dexpand"
                  >
                    <span>{{ errors.dexpand ? "展开" : "收起" }}</span>
                    <img :src="errors.dexpand ? icons.downRed : icons.upRed" alt="icon" />
                  </span>
                </p>
                <div :class="{ points: true, dexpand: errors.dexpand }">
                  <p
                    @click="locateWord(p)"
                    class="point"
                    v-for="(p, i) in errors.list"
                    :key="i"
                  >{{ p.Error }}</p>
                </div>
              </div>
            </div>
            <div class="editor—wrap-outer">
              <!-- 2 广播稿 p-->
              <div
                class="editor-inner ueditor tvWrapper radioWrapper"
                v-show="selectedType.id == 2"
              >
                <p
                  @paste="handlePaste"
                  ref="radioTextBody"
                  class="myeditor bodyPart"
                  contenteditable
                  @input="asyncText('body', 'radio', $event)"
                ></p>
              </div>
              <!-- 1类型 电视稿 有正文 导语 p -->
              <div
                class="editor-inner ueditor tvWrapper"
                v-if="selectedType.id == 1"
                id="tvWrapper"
              >
                <p class="tvBlock">[正文]</p>
                <p
                  ref="tvTextBody"
                  class="myeditor bodyPart"
                  contenteditable
                  @input="asyncText('body', 'tv', $event)"
                ></p>
                <p class="tvBlock">[导语]</p>
                <p
                  ref="tvTextLead"
                  class="myeditor"
                  contenteditable
                  @input="asyncText('lead', 'tv', $event)"
                ></p>
                <p class="tvBlock">[编后]</p>
                <p
                  ref="tvTextAfter"
                  class="myeditor"
                  contenteditable
                  @input="asyncText('after', 'tv', $event)"
                ></p>
              </div>
              <!-- 4类型 体育稿 有正文 导语 -->
              <div
                class="editor-inner ueditor tvWrapper"
                v-if="selectedType.id == 4"
                id="tvWrapper"
              >
                <p class="tvBlock">[导语]</p>
                <p
                  ref="tvTextLead"
                  class="myeditor leadPart"
                  contenteditable
                  @input="asyncText('lead', 'tv', $event)"
                ></p>
                <p class="tvBlock">[正文]</p>
                <p
                  ref="tvTextBody"
                  class="myeditor"
                  contenteditable
                  @input="asyncText('body', 'tv', $event)"
                ></p>
                <p class="tvBlock">[编后]</p>
                <p
                  ref="tvTextAfter"
                  class="myeditor"
                  contenteditable
                  @input="asyncText('after', 'tv', $event)"
                ></p>
              </div>
              <div class="editor-inner normalWrapper _hiddenNormal" v-html="normalContent"></div>
              <!-- 0新媒体稿 3记录小康稿 用ueditor -->
              <div
                class="ueditor editor-inner normalWrapper"
                v-show="selectedType.id == 0 || selectedType.id == 3"
                id="normalWrapper"
              >
                <vue-ueditor-wrap
                  @ready="normalReady"
                  v-model="normalContent"
                  :config="normalConfig"
                ></vue-ueditor-wrap>
                <p v-show="showContentTips&&selectedType.id == 3" class="tips">
                  <i>*</i>
                  从这里开始写正文
                </p>
                <div class="loadingWithContent-wrapper" v-show="transformingImgs.loading">
                  <div class="loadingWithContent">
                    <img src="@assets/img/common/loading.svg" alt="loading" />
                    <div class="title">{{ transformingImgs.msg }}</div>
                  </div>
                </div>
              </div>
              <!-- AI智能按钮 -->
              <div class="ai-btn-conatiner">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="语音合成"
                  placement="bottom"
                  :visible-arrow="false"
                  v-if="aiEditAuth.includes('voiceComposeList')"
                >
                  <div
                    
                    @click="handleVocieComposeClick"
                    class="ai-btn"
                  >
                    <div class="voiceCompose"></div>
                  </div>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="DeepSeek写稿小助手"
                  placement="bottom"
                  :visible-arrow="false"
                  v-if="aiEditAuth.includes('intelligentWriting')"
                >
                  <div
                    @click="showAiWriter"
                    
                    class="ai-btn"
                  >
                    <div class="aiWrite"></div>
                  </div>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="智能审核"
                  placement="bottom"
                  :visible-arrow="false"
                  v-if="aiEditAuth.includes('intelligentReview')"
                >
                  <div  class="ai-btn">
                    <div class="aiAudit"></div>
                  </div>
                </el-tooltip>
              </div>
            </div>
            <li class="bt check">
              <button v-if="global.has_check_content_role" @click="checkWords()">错别字检查</button>
              <div>
                <!-- <span v-if="selectedType.id == 2">{{`正文：${radioText.length}字 ${Math.ceil(bodyDurantion)}秒`}}</span> -->
                <span v-if="selectedType.id == 1 || selectedType.id == 4">
                  {{
                  `正文：${bodyText.length}字 ${Math.ceil(bodyDurantion)}秒`
                  }}
                </span>
                <span style="margin: 0 20px" v-if="selectedType.id == 1 || selectedType.id == 4">/</span>
                <span v-if="selectedType.id == 1 || selectedType.id == 4">
                  {{
                  `导语：${headText.length}字 ${Math.ceil(headDurantion)}秒`
                  }}
                </span>
                <span style="margin: 0 20px" v-if="selectedType.id == 1 || selectedType.id == 4">/</span>
                <span v-if="selectedType.id == 1 || selectedType.id == 4">
                  语速：
                  <input type="number" v-model="speed" @blur="setSpeed()" />字/分钟
                </span>

                <span
                  v-if="selectedType.id == 0 || selectedType.id == 3"
                >{{`正文：${noStyleContent.length}字 ${Math.ceil(noStyleDuration)}秒`}}</span>
                <span style="margin: 0 20px" v-if="selectedType.id == 0 || selectedType.id == 3">/</span>
                <span v-if="selectedType.id == 0 || selectedType.id == 3">
                  语速：
                  <input type="number" v-model="speed" @blur="setSpeed()" />字/分钟
                </span>
              </div>
              <!-- <button v-if="global.has_makeup_audio_role" class="end" @click="compositeAudio()">
      文稿合成音频
              </button>-->
            </li>
            <li class="bt multi">
              <div class="left-container">
                <div v-show="cover" class="cover" :style="'background-image: url('+cover+')'"></div>
                <img src="@assets/img/common/add-green.svg" alt />
                <p>添加封面</p>
                <div class="btn" v-if="!hasCover">
                  <span @click="localUpload">本地上传</span>
                  <p class="line"></p>
                  <span @click="maskMaterial">我的素材</span>
                </div>
                <div class="btn" v-if="hasCover" @click.stop="hasCover = false">
                  <span>更换封面</span>
                </div>
              </div>
              <div :class="{'right-container': true,center: selectedType.id == 3}">
                <div v-show="selectedType.id != 3 && !isRadio" class="sec">
                  <div class="title">信源</div>
                  <input type="text" v-model="global.source" />
                  <p class="line"></p>
                </div>
                <div v-if="isRadio" class="twoSec">
                  <div v-show="selectedType.id != 3" class="input">
                    <div class="title">信源</div>
                    <input type="text" v-model="global.source" />
                  </div>
                  <div v-show="selectedType.id != 3" class="input">
                    <div class="title">编辑</div>
                    <input type="text" v-model="global.editor" />
                  </div>
                </div>
                <div v-show="selectedType.id != 3 && !isRadio" class="sec">
                  <div class="title">记者</div>
                  <input type="text" v-model="global.author" />
                </div>
                <div v-if="isRadio" class="twoSec bottom">
                  <div v-show="selectedType.id != 3" class="input">
                    <div class="title">记者</div>
                    <input type="text" v-model="global.author" />
                  </div>
                  <div v-show="selectedType.id != 3" class="input">
                    <div class="title">责任编辑</div>
                    <input type="text" v-model="global.response_editor" />
                  </div>
                </div>

                <div v-show="selectedType.id == 3" class="xkInput">
                  <div style="margin-bottom: 20px" class="item">
                    <p>主创</p>
                    <input v-model="leading_creator" type="text" />
                  </div>
                  <div style="justify-content: flex-end;margin-bottom: 20px" class="item">
                    <p class="must">分类标签</p>
                    <!-- <input type="text"> -->
                    <div class="labelSelect-container">
                      <p>{{type_tag_name}}</p>
                      <span @click="labelSelect">选择</span>
                    </div>
                  </div>
                  <div :style="'margin-bottom:'+isLowWidth+'px'" class="item">
                    <p>人物</p>
                    <input v-model="person" type="text" />
                  </div>
                  <div style="justify-content: flex-end" class="item">
                    <p>项目/主题</p>
                    <input v-model="project" type="text" />
                  </div>
                </div>
              </div>
              <!-- <div class="half">
      <div class="title">信源</div>
      <input type="text" v-model="global.source" />
    </div>
    <div class="half">
      <div class="title">作者</div>
      <input type="text" v-model="global.author" />
              </div>-->
            </li>

            <li v-if="selectedType.id == 3" class="bt xkTextarea-container">
              <textarea
                maxlength="500"
                @focus="showTips = false"
                @blur="tipsBlur"
                v-model="tipsContent"
                class="xkTextarea"
              ></textarea>
              <p v-show="showTips" class="tips">
                <i>*</i>
                摘要
              </p>
              <p v-if="selectedType.id == 3" class="wordNum">{{tipsContent.length}}/500</p>
            </li>
            <!-- <li class="bt multi">
          <div class="half">
            <div class="title">记者</div>
            <input type="text" placeholder="多名记者请以空格分割" v-model="global.reporters">
          </div>
          <div class="half">
            <div class="title">摄像</div>
            <input type="text" placeholder="多名摄像请以空格分割" v-model="global.cameras">
          </div>
            </li>-->
            <li class="bt mt" v-if="!!global.topicExist">
              <button class="re" @click="openWith('withTopic')">{{ `关联${$_syscfg.topic}` }}</button>
              <span :class="{ with: !!withTopic.id }">
                <span>
                  {{
                  withTopic.title || `仅可关联1条${$_syscfg.interview}`
                  }}
                </span>
                <img
                  v-if="!!withTopic.id"
                  src="@assets/img/common/del.svg"
                  alt="del"
                  @click="deleteTpc(withTopic)"
                />
              </span>
            </li>
            <li class="bt" v-if="!!global.interviewExist">
              <button class="re" @click="openWith('withInterview')">{{ `关联${$_syscfg.interview}` }}</button>
              <span :class="{ with: !!withInterview.id }">
                <span>
                  {{
                  withInterview.title || `仅可关联1条${$_syscfg.interview}`
                  }}
                </span>
                <img
                  v-if="!!withInterview.id"
                  src="@assets/img/common/del.svg"
                  alt="del"
                  @click="deleteItv(withInterview)"
                />
              </span>
            </li>
            <li class="bt" v-if="!!global.reportExist">
              <button class="re" @click="openWithReport()">{{ `关联${$_syscfg.report}` }}</button>
              <span :class="{ with: !!withReport.id }">
                <span>{{ withReport.title || `仅可关联1条${$_syscfg.report}` }}</span>
                <img
                  v-if="!!withReport.id"
                  src="@assets/img/common/del.svg"
                  alt="del"
                  @click="deleteRpt()"
                />
              </span>
            </li>
            <div v-show="selectedType.id != 3" class="tagli tagPadding">
              <div class="gbtn" @click="generateTag()">一键生成标签</div>
              <li class="bt flx1 noBorder tagInput">
                <!-- <button class="tag" v-for="(t, i) in global.tags" :key="i">
              <span>{{t}}</span>
              <img src="@assets/img/common/del.svg" alt="del" @click="deleteTag(t)">
                </button>-->
                <span>
                  <input
                    type="text"
                    placeholder="请输入自定义标签，回车添加"
                    v-model="tag"
                    @keyup.enter="addTag"
                  />
                </span>
              </li>
            </div>
            <div v-show="selectedType.id == 3" class="tagli">
              <div class="gbtn" @click="generateTag()">一键生成标签</div>
              <li class="bt flx1 noBorder">
                <!-- <button class="tag" v-for="(t, i) in global.tags" :key="i">
              <span>{{t}}</span>
              <img src="@assets/img/common/del.svg" alt="del" @click="deleteTag(t)">
            </button> -->
      <span @click="clickTags" class="greyBg">
        <input @blur="outTags" ref="tagInput" type="text" v-model="tag" @input="tagInput" @keyup.enter="addTag">
        <p v-show="showTags" class="tips">
          <i>*</i>
          请输入自定义标签，回车添加
        </p>
        <ul v-click-outside="clearTagList">
          <li @click="tagSelect(item.title)" v-for="(item,index) in tagList" :key="index">{{item.title}}</li>
        </ul>
      </span>
    </li>
  </div>
  <div v-show="global.tags && global.tags.length > 0" class="tagli">
    <div class="tag" v-for="(t, i) in global.tags" :key="i">
      <span>{{ t }}</span>
      <img src="@assets/img/common/del.svg" alt="del" @click="deleteTag(t)" />
    </div>
  </div>
  </ul>
  </article>
  <aside class="_xnsAside">
    <mediaCenter ref="mediaCenter" :select="select" :pageType="2" v-on:getPid="getPid" :data="mediaData" @deleteMedia="deleteMedia" v-on:getInsert="getInsert" v-on:getFold="getFold"
      v-on:getUploading="getUploading" :canComposite="global.has_pickup_text_role" :canInsert="canInsert" v-on:getComplete="uploadComplete" v-on:getConfig="getUploadConfig" @setNewPublishCover="setNewPublishCover" @setNewCover="setNewCover"
      :canShowEdit="global.has_edit_audio_role" :canShowPicEdit="global.has_edit_img_role" :isPublishSrc="true" />
    <div :class="{ 'aside-content mt': true, folded: !showClue }" v-if="!!global.materialExist">
      <p class="ptitle">
        <span>{{ `关联${$_syscfg.clue}` }}</span>
        <span class="right">
          <span class="withBtn" @click="addClue()">
            <img src="@assets/img/common/add-green.svg" alt="add" />
            <span>{{ `添加${$_syscfg.clue}` }}</span>
          </span>
          <span>
            <span class="num" @click="foldClues()">
              {{ (global.materials || []).length }}
              <img :src="showClue ? icons.upward : icons.downward" alt="icon" />
            </span>
          </span>
        </span>
      </p>
      <div class="nav-content" v-show="showClue">
        <empty :msg="`暂无${$_syscfg.clue}`" v-if="global.materials && global.materials.length === 0" />
        <div class="itemContainer" v-for="(img, index) in global.materials" :key="index">
          <div class="clueItem">
            <div class="headline">
              <div class="cover">
                <img :src="img.material_img || img.cover || defaultImg" alt="cover" />
              </div>
              <p class="title">
                <span @click="goClue(img.material_id)">{{
                        img.material_title || img.title
                        }}
                      </span>
                      <img src="@assets/img/common/rm.svg" alt="del" @click="deleteClue(img)" />
                    </p>
                  </div>
                  <p v-html="img.material_content || img.content" class="detail">
                    <!-- {{ img.material_content || img.content }} -->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
      <footer>
        <li class="button left">
          <button
            :class="{ disabled: uploading }"
            @click="saveAndJump('save')"
            v-if="global.has_draft"
          >保存草稿</button>
          <button
            :class="{ disabled: uploading }"
            @click="saveAndJump('modify')"
            v-if="global.has_modify"
          >修改</button>
          <button
            :class="{ disabled: uploading }"
            @click="saveAndApprove()"
            v-if="global.has_modify"
          >修改并通过</button>
          <!-- <button :class="{'disabled': uploading}" @click="releaseAndJump('release')" v-if="global.has_release">发布</button>
          <button :class="{'disabled': uploading}" @click="toCheck()" v-if="global.has_verify">送审</button>-->
          <button
            :class="{ disabled: uploading }"
            @click="releaseAndJump('release')"
            v-if="select.depart.has_release && !global.has_modify"
          >发布</button>
          <button
            :class="{ disabled: uploading }"
            @click="toCheck()"
            v-if="select.depart.has_verify"
          >送审</button>
        </li>
        <li class="button right">
          <div
            v-if="global.has_release || global.has_verify"
            :class="{ autoPost: true, autoPostOn: autoPost.on }"
            @click="switchAutoPost()"
          >
            <img :src="autoPost.on ? autoPost.icons.on : autoPost.icons.off" alt="checker" />
            <span>{{ `传完自动${global.has_release ? "提交" : "送审"}` }}</span>
          </div>
        </li>
      </footer>
      <withTopic :from="4" ref="withTopic" @getTopic="fetchTopic" />
      <withInterview :from="4" ref="withInterview" @getInterview="fetchInterview" />
      <withClue :from="4" ref="withClue" @getClue="fetchClue" />
      <withReport ref="withReport" @getReport="fetchReport" />
      <checkers ref="checkers" />
      <div class="showSave" v-show="autoSave.show">
        <img src="@assets/img/common/right.svg" alt="right" />
        <span>已保存至草稿箱</span>
      </div>
    </div>
    <pushBox ref="pushBox" />
    <div class="lock" v-if="lock.show">
      <p class="msg">{{ `该稿件已被锁定，正在被${lock.locker}编辑` }}</p>
    </div>

    <successTip ref="successTip" />
    <audioCompose ref="audioCompose" />
    <publishPlatforms ref="publishPlatforms" v-on:getSelected="getSelected" />
    <!-- AI 优化气泡弹出框 支持输入 -->
    <!-- 如果有AI 写稿的权限 -->
    <template v-if="aiEditAuth.includes('intelligentWriting')">
      <!-- ueditor类型 todo -->
      <AiOptimizeWriter_Ueditor
        @focus="handleOptimizeWriterFocus('ueditor',$event)"
        @exchangeContent="handleExchangeContent"
        @search="searchOptimize"
        :registerOptimization="registerOptimization"
        v-if="optimizeContainer&&useUeditor"
        :optimizeContainer="optimizeContainer"
        ref="editorOptimizeUEditorRef"
        key="editorOptimizeUEditor"
      ></AiOptimizeWriter_Ueditor>
      <!-- 通用的 优化按钮 + 弹窗 适配 标题；广播稿；正文 多个p的稿件 -->
      <AiOptimizeWriter_Common
        @exchangeContent="handleExchangeContentCommon"
        @focus="handleOptimizeWriterFocus('common',$event)"
        :apply_container="apply_container"
        @search="searchOptimize"
        ref="editorOptimizeCommonRef"
        key="editorOptimizeCommon"
      ></AiOptimizeWriter_Common>
    </template>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';
import { apis } from '@common/config';
import common from '@common/common';
import headline from '@components/headline';
import mediaCenter from '@components/mediaCenter';
import withTopic from '@components/withTopic';
import withInterview from '@components/withInterview';
import withClue from '@components/withClue';
import withReport from '@components/withReport';
import dc from '@common/dc';
import checkers from '@components/checkers';
import empty from '@components/empty';
import pushBox from '@components/pushBox';
import successTip from '@components/successTip';
import audioCompose from '@components/audioCompose';
import publishPlatforms from '@components/publishPlatforms';
import DatePicker from 'vue2-datepicker';
import vClickOutside from 'v-click-outside';
import xkPicker from '@components/xkPicker';

import AiOptimizeWriter_Ueditor from '@common/aiOptimizeWriter/aiOptimizeWriter_ueditor.vue';
import AiOptimizeWriter_Common from '@common/aiOptimizeWriter/aiOptimizeWriter_Common.vue';

const BLOCK_CONTAINER_MAP = [
  'P',
  'CODE',
  'SECTION',
  'ARTICLE',
  'FOOTER',
  'ASIDE',
  'LI',
  'OL',
  'DD',
  'DL',
  'DT',
  'TR',
  'TD',
  'TABLE',
  'TBODY',
  'THEAD',
  'TFOOT',
  'TH',
  'CAPTION',
  'UL',
  'BLOCKQUOTE',
  'FIGURE',
  'HEADER',
  'MAIN',
  'NAV',
  'DIV',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'PRE',
  'TEXTAREA',
  'FRAME',
  'FORM',
  'CENTER',
  'FRAMESET',
  'ADDRESS',
  'LEGEND',
  'IFRAME',
];
const REMOVE_MAP = ['BR', 'CANVAS', 'INPUT', 'OPTION', 'SELECT', 'SOURCE', 'META'];
const INLINE_CONTAINER_MAP = ['ABBR', 'BUTTON', 'A', 'SPAN', 'EM', 'STRONG', 'B', 'I', 'U', 'LABEL', 'SMALL', 'BIG', 'HR'];
const ENTITY_MAP = ['IMG', 'VIDEO', 'AUDIO'];
// 标题最大可输入文字
const MAX_WORD_COUNT = 60;
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    VueUeditorWrap,
    headline,
    mediaCenter,
    withTopic,
    withInterview,
    withClue,
    checkers,
    empty,
    pushBox,
    successTip,
    audioCompose,
    publishPlatforms,
    withReport,
    DatePicker,
    xkPicker,

    AiOptimizeWriter_Ueditor,
    AiOptimizeWriter_Common,
  },
  data() {
    return {
      isRadio: false,
      isLowWidth: 0,
      leading_creator: '',
      edit_date: null,
      showContentTips: true,
      content_category: [],
      content_category_list: {
        list: [],
        index: 0,
      },
      content_category_index: 999,
      content_category_ids: [],
      focusInputing: false,
      hasCover: false,
      cover: '',
      isXnew: this.$store.state.isXnew,
      headLines: {
        title: '',
        showLink: false,
        filter: false,
      },
      isNew: true,
      isPush: false,
      isDraft: false,
      saveAfterCopyclues: false,
      global: {},
      speed: 330,
      mediaData: null,
      listData: null,
      selectedType: {},
      withTopic: {},
      withInterview: {},
      withReport: {},
      withClues: [],
      defaultImg: require('@assets/img/common/default.png'),
      icons: {
        downward: require('@assets/img/common/xiala.svg'),
        upward: require('@assets/img/common/upward.svg'),
        upRed: require('@assets/img/common/up-red.svg'),
        downRed: require('@assets/img/common/down-red.svg'),
      },
      tag: '',
      tmpId: '',
      uploading: false,
      showClue: false,
      normalConfig: {
        autoHeightEnabled: true,
        initialFrameHeight: 640,
        initialFrameWidth: '100%',
        enableAutoSave: false,
        autoFloatEnabled: true,
        imageScaleEnabled: false,
        saveInterval: 24 * 60 * 60 * 1000,
        topOffset: 70,
        autotypeset: {
          mergeEmptyline: true, //合并空行
          removeClass: true, //去掉冗余的class
          removeEmptyline: false, //去掉空行 todo
          // textAlign: "left", //段落的排版方式，可以是 left,right,center,justify 去掉这个属性表示不执行排版
          // imageBlockLine: "center", //图片的浮动方式，独占一行剧中,左右浮动，默认: center,left,right,none 去掉这个属性表示不执行排版
          pasteFilter: false, //根据规则过滤没事粘贴进来的内容
          clearFontSize: false, //去掉所有的内嵌字号，使用编辑器默认的字号
          clearFontFamily: false, //去掉所有的内嵌字体，使用编辑器默认的字体
          removeEmptyNode: true, // 去掉空节点
          //可以去掉的标签
          removeTagNames: { br: 1, hr: 1 },
          indent: false, // 行首缩进
          indentValue: '4px', //行首缩进的大小
          bdc2sb: false,
          tobdc: false,
        },
        toolbars: [
          [
            'undo',
            'redo',
            '|',
            'fontsize',
            '|',
            'blockquote',
            'horizontal',
            '|',
            'removeformat',
            'formatmatch',
            '|',
            'link',
            'unlink',
            'bold',
            'italic',
            'underline',
            'forecolor',
            'backcolor',
            '|',
            'indent',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            'rowspacingtop',
            'rowspacingbottom',
            'lineheight',
            'fontborder',
            // "|",
            // "imagenone",
            // "imageleft",
            // "imageright",
            // "imagecenter"
          ],
        ],
      },
      normalContent: '',
      tvText: {
        body: '',
        lead: '',
        after: '',
      },
      radioText: '',
      // tvContent: '<p>[正文]<br/><br/><br/>[导语]<br/><br/><br/>[编后]</p>',
      // originTVContent: '<p>[正文]<br/><br/><br/>[导语]<br/><br/><br/>[编后]</p>',
      tvInstance: null,
      normalInstance: null,
      bodyText: '', // 正文纯文字
      headText: '', // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0, // 导语时长
      errors: {
        list: [],
        fix: false,
        width: '',
        dexpand: false,
        showToggle: false,
        scrollTop: 0,
      },
      autoSave: {
        show: false,
        time: 30 * 1000,
        interval: null,
      },
      lock: {
        locker: '',
        show: false,
        time: 15 * 1000,
        interval: null,
      },
      pageId: '',
      watchCount: 0,
      pushList: [],
      canInsert: false,
      showNoToast: false, // 用于控制post后的toast显示，多次使用需要重置
      autoPost: {
        icons: {
          on: require('@assets/img/common/autoCheckerOn.svg'),
          off: require('@assets/img/common/autoChecker.svg'),
        },
        on: false,
      },
      pushIds: 'cancel',
      normalWindow: {},
      audioComposeConfig: {
        title: '',
        article: '',
        target: '',
        app_id: '',
        app_secret: '',
        host: '',
        page_type: '',
        page_id: 0,
      },
      select: {
        depart: {
          text: null,
          on: false,
          id: null,
          has_release: false,
          has_verify: false,
        },
        platform: {
          // text: null,
          on: false,
          // id: null
        },
      },
      saveWord: null,
      wordNum: 0,
      transformingImgs: {
        loading: false,
        msg: '',
      },
      noStyleContent: '',
      noStyleDuration: 0,
      is_sensitive: '',
      is_good: '',
      field: '',
      leader: '',
      type_tag_ids: '',
      type_tag_name: '',
      tagList: [],
      person: '',
      project: '',
      showTips: true,
      tipsContent: '',
      showTags: true,
      aiEditAuth: [],
      // ueditor 情况下 会用到这个对应 优化容器
      optimizeContainer: null,
      // AI 优化功能 应用的 编辑容器，根据权限&& 稿件类型
      apply_container: [],
      hasInitAIAuth: false,
      // 是否当前页面 使用的是 Ueditor 。 智能写稿 优化按钮交互区别
      useUeditor: false,
    };
  },
  created() {
    // 判断是新建、推送还是编辑
    const type = this.$route.query.t;
    this.isNew = !this.$route.query.d;
    this.pushId = this.$route.query.push;
    let title = '';

    if (this.isNew) {
      title = `新建${this.$_syscfg.publish}`;
    } else {
      title = `编辑${this.$_syscfg.publish}`;
    }

    if (this.pushId) {
      title = `推送${this.$_syscfg.publish}`;
    }

    this.headLines.title = title;
    this.selectedType.id = type;
    this.canInsert = this.selectedType.id != 1 && this.selectedType.id != 2 && this.selectedType.id != 4;
    // 初始化数据。是否正在抓取图片(黏贴文稿中的图片)
    this.grabingImg = false;
  },
  computed: {
    // 发布平台是否包括阿基米德
    hasAKMD() {
      return (this.global.column_info && this.global.column_info.some((e) => e.ftitle === '阿基米德')) || false;
    },
  },
  watch: {
    // tvContent: function(n, o) {
    //   this.watchContentCount()
    //   this.watchContent(n)
    // },
    // tvText: {
    //   handler: function(n, o) {
    //     console.log('watchtvtext', n)
    //     this.watchContentCount()
    //     this.watchTV()
    //   },
    //   deep: true
    // },
    /**
     * 如果从不包含=>变成包含，就要提示正在转换。并且。清洗格式
     */
    hasAKMD(n, o) {
      // 如果之前就选择了阿基米德，就不要再提示转换了
      if (this.preChosenAKMD && n) return (this.preChosenAKMD = false);
      if (n && !o) {
        this.transformingImgs = {
          loading: true,
          msg: `检测到发布平台包含阿基米德，正在转换格式...`,
        };
        // 如果向编辑器添加内容，禁止
        this.normalInstance.body.contentEditable = false;
        // 如果是纯文本。就去加换行。替换文本
        console.log('检测到hasAKMD变化 this.normalContent', this.normalContent);
        let content = this.finalFilter(this.normalInstance.body.innerHTML, 'watch');
        // 开放 编辑器添加内容
        this.normalInstance.body.contentEditable = true;
        this.normalInstance.setContent(content);
        setTimeout(() => {
          this.transformingImgs = {
            loading: false,
            msg: ``,
          };
        }, 2000);
      }
    },
    global: {
      handler: function (n, o) {
        console.log('watch global', n);
        this.watchTitle();
      },
      deep: true,
    },
    radioText: {
      handler: function (n, o) {
        console.log('watchradio', n);
        this.watchContentCount();
        this.watchRadio();
      },
      deep: true,
    },
    hasInitAIAuth(nv) {
      if (nv && this.aiEditAuth.includes('intelligentWriting')) {
        // 赋值 标题
        //  if (this.aiEditAuth.includes('intelligentWriting')) {

        this.$nextTick(() => {
          this.initApplyContainer();
          console.log('如果有智能写稿权限 替换 标题');
          this.$refs.title_editorRef.innerHTML = this.global.title;
        });
        // }
      }
    },
    tvText: {
      handler: function (n, o) {
        console.log('watchtvtext', n);
        this.watchContentCount();
        this.watchTV();
      },
      deep: true,
    },
    normalContent: function (n, o) {
      this.watchContentCount();
      this.calculateText();
      if (this.normalContent.length == 0) {
        this.showContentTips = true;
      } else {
        this.showContentTips = false;
      }
    },
    selectedType: {
      deep: true,
      immediate: true,
      handler(nv) {
        console.log('watch selectedType', nv, nv && nv.id);
        // 如果是 需要展示 ueditor格式的
        if (nv && (nv.id == 0 || nv.id == 3)) {
          this.useUeditor = true;
        } else {
          this.useUeditor = false;
        }
      },
    },
    useUeditor(nv) {
      console.log('watch useUeditor', nv);
    },
  },
  methods: {
    handleExchangeContentCommon(text) {
      console.log('handleExchangeContentCommon html', text);
      // 将复制进来的 html结果 取出text
      let newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsEmpty(this.replaceNBSP2Blank(text));
      text = newNode.innerText.trim();
      // 释放 node
      newNode = null;

      let copyTextLength = this.getLength2(text);

      // 如果超过了 最大字数。要截取
      if (this.wordNum + copyTextLength > MAX_WORD_COUNT) {
        text = text.substring(0, MAX_WORD_COUNT - this.wordNum);
      }
      // 插入纯文本
      console.log('替换 title text', text);

      this.$refs.title_editorRef.innerHTML = text;
      this.global.title = text;
    },
    handleExchangeContent(data) {
      this.normalContent = data;
    },
    removeHighlight() {
      console.log('removeHighlight', this.global.title);
      let html = `<li data-v-fa88855e="" class="bt mt"><button data-v-fa88855e="" class="re">关联选题库</button><span data-v-fa88855e="" class=""><span data-v-fa88855e="">
                仅可关联1条采访
              </span><!----></span></li>`;
      this.currentOptimizeWriter.editor.copy(html);
    },
    initApplyContainer() {
      let list = [];

      list = [this.$refs.title_editorRef];
      // 如果是 广播稿类型
      if (this.selectedType.id == 2) {
        list.push(this.$refs.radioTextBody);
      }
      // 如果是体育稿 或者 电视稿  好像广播没有
      if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        list = [this.$refs.title_editorRef, this.$refs.tvTextBody, this.$refs.tvTextLead, this.$refs.tvTextAfter];
      } else if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        this.useUeditor = true;
      }
      //  如果是 新媒体稿 另外新增一个组件 common的只用于title

      console.log('initApplyContainer list', list);
      this.apply_container = list;
    },
    replaceNBSP2Blank(source) {
      return source.replace(/&nbsp;/gi, ' ');
    },
    replaceBrTagsWithNewlines(str) {
      return str.replace(/<br\s*\/?>/gi, '\n');
    },
    replaceBrTagsEmpty(str) {
      str = str.replace(/<br\s*\/?>/gi, '\n').replaceAll('\n', '');
      console.log('第一次 str', str);
      str = str.trim();
      console.log('trim完', str);
      return str;
    },
    // todo
    handlePaste(e) {
      // 阻止默认行为，避免直接粘贴内容
      e.preventDefault();
      // 将 br 变成\n
      // 将 &nbsp; 变成' '

      // 获取剪贴板中的文本数据
      const text = (e.clipboardData || window.clipboardData).getData('text');

      // 插入自定义处理后的文本
      document.execCommand('insertText', false, this.replaceBrTagsWithNewlines(this.replaceNBSP2Blank(text)));

      console.log('Paste event handled', text);
    },
    // 每次点击搜索 都重新打开 优化完整弹窗 todo
    searchOptimize(rest) {
      console.log('searchOptimize rest', rest);
      this.showOptimizeDialog(true);
      console.log('之前赋值的 AiOptimizeWriter', this.AiOptimizeWriter);
      // 搜索内容。
      this.AiOptimizeWriter.initSearch(rest);
    },
    /**
     * 优化的 可编辑区域 focus
     * 更新 当前的 编辑器
     */
    handleOptimizeWriterFocus(type, editor) {
      console.log('handleOptimizeWriterFocus type', type);
      console.log('handleOptimizeWriterFocus editor', editor);
      // todo 处理失焦的时候，更新掉 currentOptimizeWriter
      if (this.currentOptimizeWriter) {
        if (editor != this.currentOptimizeWriter.editor) {
          this.currentOptimizeWriter.editor.clearSelfSelection();
        }
      }

      this.currentOptimizeWriter = {
        type,
        editor,
      };
    },
    // 处理 uedtior 和 common 都有的情况
    showAiWriter() {
      if (!this.AiWriter) {
        let AiWriter = (this.AiWriter = this.$AiWriter());
        this.AiWriter.$on('copy', (data = '') => {
          console.log('智能写稿 替换操作', data);
          let containerText;
          let optimizeEditor;

          // 如果是 新媒体稿件 ueditor
          if (this.selectedType.id == 0 || this.selectedType.id == 3) {
            containerText = this.normalContent;
            optimizeEditor = this.$refs.editorOptimizeUEditorRef;
          }
          // 如果是 广播稿 p标签
          else if (this.selectedType.id == 2) {
            containerText = this.radioText;
            optimizeEditor = this.$refs.editorOptimizeCommonRef;
          }
          // 如果原本 无 内容
          if (!containerText.trim()) {
            if (this.selectedType.id == 0 || this.selectedType.id == 3) {
              this.normalContent = data.trim();
            } else if (this.selectedType.id == 2) {
              this.$refs.radioTextBody.innerText = data.trim();
              this.radioText = data.trim();
            }
          }
          // 如果原本编辑器内 没有文本
          else {
            optimizeEditor.copy(data.trim());
          }
        });

        this.AiWriter.$on('exchangeContent', (data = '') => {
          console.log('智能写稿 exchangeContent', data);
          // 如果是 新媒体稿件 ueditor
          if (this.selectedType.id == 0 || this.selectedType.id == 3) {
            this.normalContent = data;
          }
          // 如果是 广播稿 p标签
          else if (this.selectedType.id == 2) {
            this.radioText = data;
          }
        });

        console.log('AiWriter 建立完', AiWriter);
      } else {
        this.AiWriter.toggleShowContent();
      }
    },
    // 右侧显示 优化的聊天窗 todo
    // 这个 还有标题也可以复制的
    showOptimizeDialog(show) {
      if (!this.AiOptimizeWriter) {
        let AiOptimizeWriter = (this.AiOptimizeWriter = this.$AiOptimizeWriter());

        this.AiOptimizeWriter.$on('copy', (param) => {
          console.log('优化 copy', param);
          // 得知道当前 focus的 优化项是什么
          if (this.currentOptimizeWriter && this.currentOptimizeWriter.editor) {
            // let html = `<li data-v-fa88855e="" class="bt mt"><button data-v-fa88855e="" class="re">关联选题库</button><span data-v-fa88855e="" class=""><span data-v-fa88855e="">
            //     仅可关联1条采访
            //   </span><!----></span></li>`;
            // this.currentOptimizeWriter.editor.copy(html);
            this.currentOptimizeWriter.editor.copy(param);
          }
        });
        //
        this.AiOptimizeWriter.$on('hide', () => {
          if (this.currentOptimizeWriter && this.currentOptimizeWriter.editor) {
            this.currentOptimizeWriter.editor.clearSelfSelection();
          }
        });
        console.log('AiOptimizeWriter 建立完', AiOptimizeWriter);
      } else {
        this.AiOptimizeWriter.toggleShowContent(show);
      }
    },
    clearTagList() {
      this.tagList = [];
    },
    tagInput(e) {
      if (this.selectedType.id == 3) {
        this.watchTag(e.target.value);
      }
    },
    tagSelect(title) {
      this.tag = title;
      this.$nextTick(() => {
        this.tagList = [];
      });
    },
    watchTag(name) {
      const info = {
        key_word: name,
      };

      common.myFetch(apis.taglist, info).then((el) => {
        this.tagList = el;
        // console.log(el)
      });
    },
    clickTags() {
      this.showTags = false;
      this.$refs.tagInput.focus();
    },
    outTags() {
      if (this.tag.length == 0) {
        this.showTags = true;
      }
    },
    tipsBlur() {
      if (this.tipsContent.length == 0) {
        this.showTips = true;
      }
    },
    calculateWidth() {
      if (document.body.offsetWidth < 1575) {
        this.isLowWidth = 20;
      } else {
        this.isLowWidth = 0;
      }
    },
    labelSelect() {
      this.$LabelSelect(this.global.type_tag).then((ele) => {
        // console.log(el)
        var arr = [];
        var name = [];
        if (ele.length > 0) {
          console.log(ele);
          ele.forEach((el) => {
            el.son_list.forEach((val) => {
              if (val.selected) {
                arr.push(val.id);
                name.push(val.name);
              }
            });
          });
          arr = arr.join(',');
          name = name.join(',');
          this.type_tag_ids = arr;
          this.type_tag_name = name;
        } else {
          this.type_tag_ids = arr;
          this.type_tag_name = name;
        }
      });
    },
    isSens(e) {
      // console.log(e)
      this.is_sensitive = e;
    },
    isJP(e) {
      // console.log(e)
      this.is_good = e;
    },
    selectArea(e) {
      // console.log(e)
      this.field = e;
    },
    selectLeader(e) {
      // console.log(e)
      this.leader = e;
    },
    selectedContent(e, index) {
      if (!e.selected) {
        this.content_category.forEach((el, index1) => {
          if (index1 == this.content_category_index) {
            el.selected = true;
          } else {
            el.selected = false;
          }
          el.son_list.forEach((el1) => {
            el1.selected = false;
          });
        });
        this.$set(e, 'selected', true);
        if (e.selected) {
          e.parentName = this.content_category[this.content_category_index].name;
          e.parentId = this.content_category[this.content_category_index].id;
          this.content_category_ids = [];
          this.content_category_ids.push(e);
          this.focusInputing = false;
        }
      }
    },
    selectedContent1(e, index) {
      console.log(index);
      this.content_category_index = index;
    },
    delContent(e) {
      console.log(e);
      this.content_category_ids = this.content_category_ids.filter((el) => {
        return el.id != e.id;
      });
      this.content_category.forEach((el) => {
        if (el.id == e.parentId) {
          el.son_list.forEach((val) => {
            if (val.id == e.id) {
              val.selected = false;
            }
          });

          let num = 0;
          el.son_list.forEach((val) => {
            if (val.selected) {
              num++;
            }
          });

          if (num == 0) {
            el.selected = false;
          }
        }
      });
    },
    closeContentCategory() {
      this.focusInputing = false;
      if (this.content_category_ids.length == 0) {
        this.content_category_index = 999;
      }
    },
    setNewPublishCover(e) {
      let i = {
        t: 2,
        d: this.$route.query.d,
        url: e.cover,
        isMedia: true,
        canEdit: true
      }
      this.$picEditType1(i, this.$refs.mediaCenter.getFlashfile).then(res => { 
        // console.log(res)
        this.cover = res.cover;
        this.hasCover = true;
        this.$refs.mediaCenter.getFlashfile()
        this.postData('auto')
        // common.myFetch(apis.setPublishcover, {
        //   id: this.$route.query.d,
        //   file_id: res.file_id,
        //   delete_file_id: e.file_id
        // }).then(r => {
        //   if(r){
        //     this.$refs.mediaCenter.getFlashfile()
        //   }
        // })
      });
    },
    setNewPublishCover(e) {
      let i = {
        t: 2,
        d: this.$route.query.d,
        url: e.cover,
        isMedia: true,
        canEdit: true
      }
      this.$picEditType1(i, this.$refs.mediaCenter.getFlashfile).then(res => { 
        // console.log(res)
        this.cover = res.cover;
        this.hasCover = true;
        this.$refs.mediaCenter.getFlashfile()
        this.postData('auto')
        // common.myFetch(apis.setPublishcover, {
        //   id: this.$route.query.d,
        //   file_id: res.file_id,
        //   delete_file_id: e.file_id
        // }).then(r => {
        //   if(r){
        //     this.$refs.mediaCenter.getFlashfile()
        //   }
        // })
      });
    },
    setNewCover(e) {
      let i = {
        t: 2,
        d: this.$route.query.d,
        url: e,
        isMedia: true,
        canEdit: true
      }
      this.$picEditType1(i, this.$refs.mediaCenter.getFlashfile).then(res => { 
        // console.log(res)
        this.$refs.mediaCenter.getFlashfile()
        this.cover = res.cover;
        this.hasCover = true;

        this.postData('auto')
      });
    },
    localUpload() {
      let httpUpBtn = document.querySelector('#httpUpBtn1');
      httpUpBtn.click();
      this.$refs.mediaCenter.localUploadCover = true;
    },
    maskMaterial() {
      this.$refs.mediaCenter
        .showMaterialListBox1("myMaterial", false, true)
        .then(res => {
          let oldId = res.id
          let i = {
            t: 2,
            d: this.$route.query.d,
            url: res.cover,
            isMedia: true,
            canEdit: true
          }
          this.$picEditType1(i, this.$refs.mediaCenter.getFlashfile).then(res => { 
            this.cover = res.cover;
            this.hasCover = true;
            this.$refs.mediaCenter.getFlashfile()
            this.postData('auto')
            // common.myFetch(apis.setPublishcover, {
            //   id: this.$route.query.d,
            //   file_id: res.file_id,
            //   delete_file_id: oldId
            // }).then(r => {
            //   if(r){
            //     this.$refs.mediaCenter.getFlashfile()
            //   }
            // })
          });
          // this.cover = res;
          // this.hasCover = true;
        });
    },
    async handlePasteTitle(event) {
      event.preventDefault();

      let text = (event.clipboardData || window.clipboardData).getData('text/plain');
      // 将复制进来的 html结果 取出text
      let newNode = document.createElement('span');
      newNode.innerHTML = this.replaceBrTagsEmpty(this.replaceNBSP2Blank(text));
      text = newNode.innerText.trim();
      // 释放 node
      newNode = null;

      let copyTextLength = this.getLength2(text);

      // 如果超过了 最大字数。要截取
      if (this.wordNum + copyTextLength > MAX_WORD_COUNT) {
        text = text.substring(0, MAX_WORD_COUNT - this.wordNum);
      }
      // 插入纯文本
      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      selection.deleteFromDocument();
      selection.getRangeAt(0).insertNode(document.createTextNode(text));
      selection.collapseToEnd();

      // 手动触发input事件
      this.$nextTick(() => {
        const event = new Event('input', { bubbles: true });
        this.$refs.title_editorRef.dispatchEvent(event);
      });
    },
    /**
     * 暴露给 智能 优化编辑器的 处理title的方法
     */
    handlePasteTitleExpose(text, wordNum) {
      console.log('handlePasteTitleExpose text', text);
      console.log('handlePasteTitleExpose wordNum', wordNum);
      let copyTextLength = this.getLength2(text);
      console.log('handlePasteTitleExpose text', copyTextLength);
      // 如果超过了 最大字数。要截取
      if (this.wordNum - wordNum + copyTextLength > MAX_WORD_COUNT) {
        console.log('如果超过了 最大字数。要截取');
        text = text.substring(0, MAX_WORD_COUNT - this.wordNum + wordNum);
      } else {
        console.log('没超');
      }
      console.log(' handlePasteTitleExpose substring 之后', text);
      return text || '';
    },
    handleCompositionStart(e) {
      this.isComposing = true;
    },
    // 如果中文输入法，略过了 keydown的 阻止行为
    handleCompositionEnd(e) {
      this.isComposing = false;

      let text = e.target.innerText;
      let len = this.getLength2(text);

      // 如果已经达到最大长度，阻止输入（除了退格、删除等键）
      if (len > MAX_WORD_COUNT) {
        console.log('当前已达最大字数 handleCompositionEnd 组织默认行文');
        this.$refs.title_editorRef.innerText = text.substring(0, MAX_WORD_COUNT);
        this.global.title = text.substring(0, MAX_WORD_COUNT);
        // 恢复之前保存的光标位置
        this.moveCursorToEnd();
      }
    },
    moveCursorToEnd() {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(this.$refs.title_editorRef);
      range.collapse(false); // false表示移动到末尾

      selection.removeAllRanges();
      selection.addRange(range);
      selection.collapseToEnd();
    },

    handleKeyDownTitle(event) {
      // 正在IME输入时不处理
      if (this.isComposing) return;

      // 阻止回车键
      if (event.key === 'Enter') {
        event.preventDefault();
      }
      // 空 会自动加 br。删掉
      if (['Backspace', 'Delete'].includes(event.key)) {
        if (event.target.innerText.trim() == '' && event.target.innerHTML == '<br>') {
          event.target.innerHtml = '';
          this.global.title = '';
          this.getLength('');
        }
      }

      // 如果已经达到最大长度，阻止输入（除了退格、删除等键）
      if (this.wordNum >= MAX_WORD_COUNT && !this.isControlKey(event)) {
        event.preventDefault();
      }
    },
    isControlKey(event) {
      // 判断是否是控制键
      return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'].includes(event.key);
    },

    // 输入的时候 应该不会 同时有 高亮元素
    handleInputTitle(e) {
      console.log('handleInputTitle e', e, e.target.innterText);
      if (e.target.innerText.trim() == '' && e.target.innerHTML == '<br>') {
        console.log('删到剩下 br换行');
        e.target.innerHTML = '';
      }

      // global.title 不包含标签的。纯文本
      this.global.title = e.target.innerText;
    },
    watchTitle() {
      var str = this.global.title;
      this.getLength(str);
    },
    getLength(str) {
      var n = null;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
          n += 1;
        } else {
          n += 1;
        }
      }

      if (n <= 60) {
        this.saveWord = this.global.title;
      } else {
        let key = this.global.title.substring(0, 60);
        this.global.title = key;
      }

      this.wordNum = Math.floor(n);
      console.log('getLength wordNum', this.wordNum);
    },
    getLength2(str) {
      var n = null;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
          n += 1;
        } else {
          n += 1;
        }
      }

      return n;
    },
    getUser() {
      common.myFetch(apis.Usr_menu, {}).then((r) => {
        if (r) {
          console.log(r);
          if (this.global.author == '' || this.global.author == null || this.global.author == undefined) {
            this.global.author = r.truename;
          }
        }
      });
    },
    selectUp(t, x, open) {
      if (!open) return;

      if (x) {
        this.select[t].text = x.title;
        this.select[t].id = x.id;
        this.select[t].has_release = !!x.has_release;
        this.select[t].has_verify = !!x.has_verify;
        this.pushList = x.pushto_platform;
      } else {
        window.document.addEventListener('click', this.hideDep);
      }

      this.select[t].on = !this.select[t].on;
    },
    hideDep() {
      this.select['depart'].on = false;

      window.document.removeEventListener('click', this.hideDep);
    },
    /**
     * 审核状态下 预览 检测内容变化才提交修改
     */
    viewUrl(i, t) {
      console.log(t);
      // 预览
      var urlArr = i.split('?');
      console.log('i', i);
      // todo 预览1
      let hasChanged = this.checkInitailContentChange();
      console.log('hasChanged', hasChanged);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split('&');
        urlArr = urlArr[0].split('=');

        let id = urlArr[1];
        console.log('11 urlArr', urlArr);
        console.log('11 id', id, !!id);
        console.log('11 this.previewUrl', this.previewUrl, !!this.previewUrl);
        let hasId = id || this.previewUrl;
        console.log('hasId', hasId);
        // 如果变化了。或者没有id
        if (hasChanged || !hasId) {
          console.log('如果变化了。或者没有id');
          // let operation = this.global.has_draft ? 'save' : 'modify'
          let operation = 'auto';
          this.postData(operation).then((r) => {
            if (r) {
              console.log('viewUrl r', r);
              if (urlArr[1] == undefined || urlArr[1] == null || urlArr[1] == '') {
                i += r;
              }
              console.log('最后的i', i);
              this.previewUrl = i;
              this.$audit(i, t);
            }
          });
        } else {
          // return this.$audit(id ? i : this.previewUrl);
          let operation = 'auto';
          this.postData(operation).then((r) => {
            if (r) {
              console.log('viewUrl r', r);
              if (urlArr[1] == undefined || urlArr[1] == null || urlArr[1] == '') {
                i += r;
              }
              console.log('最后的i', i);
              this.previewUrl = i;
              this.$audit(i, t);
            }
          });
        }
      } else {
        this.$audit(i, t);
      }
    },
    uploadComplete() {
      if (!this.autoPost.on) {
        this.postData('auto');

        return;
      }

      if (this.global.has_release) {
        console.log('执行发布');
        this.releaseAndJump('release');
      } else if (this.global.has_verify) {
        console.log('执行送审');
        this.toCheck();
      }
    },
    async switchAutoPost() {
      if (!this.autoPost.on) {
        // 切换为选中
        const allNeeds = this.checkNeeds();
        if (!allNeeds) return;

        this.showNoToast = true;
        let id = await this.postData('save');
      }

      this.$set(this.autoPost, 'on', !this.autoPost.on);
    },
    checkNeeds() {
      // 检查必填项
      let allNeeds = true;
      let msgs = [];
      let msg = '';

      if (!this.global.title) {
        msgs.push('标题');
        allNeeds = false;
      }

      if (this.global.column_info.length === 0) {
        msgs.push('发布平台');
        allNeeds = false;
      }

      if (!allNeeds) {
        msg = `${msgs.join('、')}不能为空`;
        this.$toast(msg);
      }

      return allNeeds;
    },
    asyncText(key, type = 'tv', e) {
      console.log('asyncText key', key, type, e);
      // 模拟vmodel，监听电视稿输入元素
      const text = e.target.innerText;
      if (type == 'radio') {
        this.radioText = text;
      } else {
        this.tvText[key] = text;
      }
    },
    beforeunload_normal(e) {
      console.log('beforeunload_normal', e);
      const event = e || window.event;
      return (event.returnValue = true);
    },
    beforeunload_akmd() {
      console.log('beforeunload_akmd 会去清洗标签和保存');
      this.postData('auto', 'beforeunload');
      return true;
    },
    watchContentCount() {
      if (this.watchCount > 2) {
        window.addEventListener('beforeunload', this.beforeunload_normal);
      }
      this.watchCount += 1;
      this.setAutosave();
    },
    getUploading(s) {
      this.uploading = s;

      if (this.uploading) {
        window.addEventListener('beforeunload', this.beforeunload_normal);
      }
    },
    /**
     * 定时 自动保存
     */
    handleAutoSave() {
      console.log('handleAutoSave 自动保存');
      try {
        this.postData('auto').then((r) => {
          if (r) {
            this.showSaveTip();
          }
        });
      } catch (e) {
        console.log('自动保存 失败 e', e);
      }
    },
    handleLock() {
      const info = {
        id: this.$route.query.d || this.tmpId,
      };

      try {
        common
          .myFetch(apis.publish_lock, {
            data: info,
            hideLoading: this.grabingImg,
          })
          .then((r) => {
            if (r) {
              // console.log("lock", r);
            }
          });
      } catch (e) {
        console.log('publish_lock e', e);
      }
    },
    handleUnlock() {
      const id = this.pageId || this.tmpId;
      if (!id) return;

      const info = {
        id: id,
      };

      try {
        common.myFetch(apis.publish_unlock, info).then((r) => {
          if (r) {
            console.log('unlock', r);
          }
        });
      } catch (e) {
        console.log('publish_unlock e', e);
      }
    },
    showSaveTip() {
      // 显示自动保存提示
      this.autoSave.show = true;

      setTimeout(() => {
        this.autoSave.show = false;
      }, 2000);
    },
    cleanMark(content) {
      // 清除mark
      content = content.replace('<mark>', '').replace('</mark>', '');

      return content;
    },
    replaceWord(content, word, start, end) {
      //  将需要标注的词用标签标注，并替换到文本中
      content = this.cleanMark(content);
      content = `${content.substring(0, start)}<mark>${word}</mark>${content.substring(end)}`;

      return content;
    },
    locateWord(w) {
      // 定位文字
      if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        this.tvContent = this.replaceWord(this.tvContent, w.Error, w.Pos, w.Pos + w.WordsLen);
      } else {
        this.normalContent = this.replaceWord(this.normalContent, w.Error, w.Pos, w.Pos + w.WordsLen);
      }

      const normalDom = this.normalInstance.document;
      // const tvDom = this.tvInstance.document
      const dom = this.selectedType.id == 1 || this.selectedType.id == 4 ? tvDom : normalDom;
      const range = new window.UE.dom.Range(dom);
      // const errors = document.querySelector('.errors')

      setTimeout(() => {
        const node = dom.getElementsByTagName('mark')[0];
        const wrapper = this.selectedType.id == 1 || this.selectedType.id == 4 ? document.getElementById('tvWrapper') : document.getElementById('normalWrapper');
        const endPos = wrapper.getBoundingClientRect().top + 80;

        range.selectNode(node).select();
        range.scrollToView(window, endPos);
      }, 200);
    },
    checkWords() {
      // 检测错别字
      this.errors.list = [];
      this.errors.dexpand = false;
      this.errors.showToggle = false;
      let content = '';
      if (this.selectedType.id == 1) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);

        content = `<p>[正文]</p><p>${body}</p><p>[导语]</p><p>${lead}</p><p>[编后]</p><p>${after}</p>`;

        content = common.replaceN2Br(content);
      } else if (this.selectedType.id == 4) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);

        content = `<p>[导语]</p><p>${lead}</p><p>[正文]</p><p>${body}</p><p>[编后]</p><p>${after}</p>`;

        content = common.replaceN2Br(content);
      } else if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        content = this.normalContent;
      } else if (this.selectedType.id == 2) {
        content = `<p>${this.radioText}</p>`;

        content = common.replaceN2Br(content);
      }

      const info = {
        content: content,
      };

      try {
        common.myFetch(apis.File_checkWord, info).then((res) => {
          if (res) {
            // this.errors.list = res

            if (res.length === 0) {
              this.$toast('没有检测到错别字');
              return;
            }
            const type = this.selectedType.id - 0;
            const typoData = {
              type: type,
              content: content,
              errors: res,
            };

            this.$typo(typoData).then((r) => {
              if (!r) return;

              if (type === 1 || type === 4) {
                this.$refs.tvTextBody.innerText = r.body;
                this.$refs.tvTextLead.innerText = r.lead;
                this.$refs.tvTextAfter.innerText = r.after;
                this.tvText = {
                  body: r.body,
                  lead: r.lead,
                  after: r.after,
                };
              } else if (type === 0 || type === 3) {
                this.normalContent = r.content;
              } else if (type === 2) {
                this.$refs.radioTextBody.innerText = r.content;
                this.radioText = r.content;
              }
            });
          }
        });
      } catch (e) {
        console.log('publish_unlock e', e);
      }
    },
    setSpeed() {
      // 设置语速并计算时长
      let speed = this.speed;
      if (this.speed > 500) {
        speed = 500;
      }
      if (this.speed < 0) {
        speed = 0;
      }
      this.speed = speed;

      this.calculateText();
    },
    watchTV() {
      this.watchTVcontent();

      this.calculateText();
    },
    watchRadio() {
      this.calculateRadio();
    },
    watchTVcontent() {
      // 检测电视稿内容格式
      const extraBodys = this.tvText.body.indexOf('[正文]') > -1;
      const extraLeads = this.tvText.lead.indexOf('[导语]') > -1;
      const extraAfters = this.tvText.after.indexOf('[编后]') > -1;
      let msg = '请保证电视稿中有且只有一个';
      const msgList = [];

      if (extraBodys) {
        msgList.push('[正文]');
      }

      if (extraLeads) {
        msgList.push('[导语]');
      }

      if (extraAfters) {
        msgList.push('[编后]');
      }

      if (msgList.length > 0) {
        msg += msgList.join('、');

        this.$toast(msg, 1000);
      }
    },
    calculateRadio() {
      // 计算时长, 广播
      const gap = 60 / this.speed;
      this.bodyText = common.replacePunctuations(this.radioText);

      this.bodyDurantion = gap * this.bodyText.length;
    },
    calculateText() {
      // 计算时长, 电视稿
      if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        const gap = 60 / this.speed;
        this.headText = common.replacePunctuations(this.tvText.lead);
        this.bodyText = common.replacePunctuations(this.tvText.body);

        this.bodyDurantion = gap * this.bodyText.length;
        this.headDurantion = gap * this.headText.length;
      } else if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        const gap = 60 / this.speed;
        this.noStyleContent = common.replacePunctuations(this.normalInstance.getContentTxt());

        this.noStyleDuration = gap * this.noStyleContent.length;
      }
    },
    // todo 22
    // 黏贴进来纯文本。要给换行符加上p
    deposePlainText(textPlain) {
      console.log('deposePlainText 处理纯文本', textPlain);
      let ps = textPlain.split('\n');
      let index = textPlain.indexOf('\n');
      console.log('ps', ps);
      console.log('/n index', index);
      let wrapper = this.normalWindow.document.createElement('p');
      let node = wrapper.cloneNode(true);
      // 如果有换行
      if (index < 0) {
        return textPlain;
      }
      // 如果没换行
      else {
        ps.forEach((e) => {
          let item = node.cloneNode(true);
          item.innerText = e;
          console.log('item', item);
          wrapper.appendChild(item);
        });
      }

      console.log('inner', wrapper);
      return wrapper.innerHTML;
    },

    registerOptimization() {
      console.log('registerOptimization normalWindow', this.normalWindow);
      console.log('registerOptimization optimizeContainer 111', this.optimizeContainer);
      // 给 编辑器 添加 样式class 限定
      this.optimizeContainer.classList.add('ai-ueditor');

      // this.normalInstance.addListener('selectionchange', (...rest) => {
      //   // ueditor 内部的 selection 对象
      //   const editorSelection = this.normalInstance.selection;
      //   const editorRange = selection._bakRange;

      //   // 可以拿到原生的 selection 对象
      //   const selectionNative = this.normalInstance.selection.getNative();
      //   const selectionNormal = this.normalWindow.getSelection();

      //   const innerRange = selectionNative.getRangeAt(0);
      this.$nextTick(() => {
        console.log('ref editorOptimizeUEditorRef ', this.$refs.editorOptimizeUEditorRef.registerOptimizationInner);
        this.$refs.editorOptimizeUEditorRef.registerOptimizationInner(this.normalInstance);
      });
    },
    /**
     * 发布时才 清洗标签
     */
    normalReady(i) {
      this.normalInstance = i;
      this.normalWindow = i.window;
      console.log('normalInstance 编辑器', this.normalInstance);
      // todo 注册 选中文本 弹出优化逻辑
      // this.registerOptimization();
      this.optimizeContainer = this.normalInstance.body;
      console.log('normalReady optimizeContainer', this.optimizeContainer);
      // 黏贴文章进去,要处理成阿基米德平台要的格式
      this.listenPaste(i);
      this.init(); // 由于使用v-show电视稿时也会执行这里
      this.normalInstance.addListener('focus', () => {
        this.$store.commit('setShowAvatar');
        this.$store.commit('setShowUpload');
        this.$store.commit('setShowStorage');
        this.$store.commit('setShowMessage');
      });
      i.addListener('focus', () => (this.showContentTips = false));
      i.addListener('blur', () => {
        if (this.normalContent.length == 0) {
          this.showContentTips = true;
        }
      });
    },
    listenPaste(i) {
      i.addListener('beforepaste', async (eventName, htmlObj) => {
        console.log('beforepaste ');
        let html = htmlObj.html;
        console.log('beforepaste html', html);
        // 移除 编辑器自动加的 text-wrap-mode:nowrap 导致不换行
        html =this.filterPasteNoWrap(html);
        // 黏贴过滤掉音频和视频
        html = this.filterVideoAndAudio(html);

        // **** 重要！！ 阻止原来的黏贴行为 ****
        htmlObj.html = '';

        // 如果不是阿基米德平台，只要替换图片地址即可
        if (!this.hasAKMD) {
          let c = await this.handleGrabWXimg(html);
          let ueditorDocument = this.normalWindow.document;
          let fragment = ueditorDocument.createElement('p');
          fragment.innerHTML = c;
          fragment.querySelectorAll('img').forEach((el) => {
            el.style.maxWidth = '100%';
          });
          i.execCommand(
            'inserthtml',
            fragment.innerHTML
            // await this.handleGrabWXimg(clipboardRealData)
          );
        }
        // 如果是阿基米德，先转换格式，再换图片地址
        else {
          let topNode = i.window.document.createElement('p');
          topNode.innerHTML = html;
          console.log('黏贴进来的html', topNode);
          let transformedHtml = this.filterTags(topNode.cloneNode(true), i.window.document, 'finalFilter');
          console.log('完成 transformedHtml', transformedHtml);
          i.execCommand('inserthtml', await this.handleGrabWXimg(transformedHtml));
        }
      });
    },
    /**
     * 根据阿基米德
     * 最终过滤一遍标签格式
     * 1.去除br标签
     * 2.因为audio特殊格式，避免过滤带class为 smg-audio的标签
     * 3.编辑过程中的strong、em、u的标签去除嵌套，往下层带样式
     */
    finalFilter(html, hint) {
      console.log('hint', hint);
      // 如果是纯文本。就加换行
      let wrapElement = this.normalWindow && this.normalWindow.document.createElement('p');
      wrapElement.innerHTML = html;

      console.log('finalFilter html', wrapElement);
      return this.filterTags(wrapElement.cloneNode(true), this.normalWindow.document, 'finalFilter');
    },
    /**
     * 在mediaCenter中删除多媒体，在编辑器中也要删除对应的文件
     * 如果是audio 要通过idstring删除
     * type :0 图片，1 视频 ，2 音频嵌在iframe中
     */
    deleteMedia({ src, idstring, type }) {
      let tag = type == 0 ? 'img' : type == 1 ? 'video' : 'audio';
      let allMedia = this.normalWindow.document.querySelectorAll(tag);
      if (tag === "img" || tag === "video") {
        if(tag === "img"){
          this.delCover(src)
        }
        [...allMedia].filter(m => m.src.indexOf(src) >= 0).forEach(m => {
          m.parentNode.removeChild(m);
          m = null;
        });
      }
      // 如果是音频。就要 删掉带smg-audio class 的标签和 audio的标签
      else if (tag === 'audio') {
        [...allMedia]
          .filter((m) => m.src.indexOf(src) >= 0)
          .forEach((m) => {
            console.log('当前audio', m);
            let audioP = m.parentNode;
            let posterP = m.parentNode.nextSibling;
            let infoP = posterP.nextSibling;
            let clearP = infoP.nextSibling;
            console.log('audioP', audioP);
            console.log('posterP', posterP);
            console.log('infoP', infoP);
            console.log('clearP', clearP);
            audioP.parentNode.removeChild(audioP);
            posterP.parentNode.removeChild(posterP);
            infoP.parentNode.removeChild(infoP);
            clearP.parentNode.removeChild(clearP);
            audioP = null;
            posterP = null;
            infoP = null;
            clearP = null;
          });
      }
    },
    /**
     * @param {html} 黏贴的文本
     * 黏贴文章时，上传图片给后台，换成smg图片地址
     */
    async handleGrabWXimg(html) {
      console.log('handleGrabWXimg html', html);
      let ueditorDocument = this.normalWindow.document;
      let fragment = ueditorDocument.createElement('p');
      fragment.innerHTML = html;
      // 过滤掉已经是smg的图片;过滤掉base64的图片
      // todo 过滤阿基米德平台的url前缀
      let imgs = [...fragment.querySelectorAll('img')].filter((img) => img.src.indexOf('media.smgtech.net') < 0 && img.src.indexOf('base64') < 0);
      if (!imgs || !imgs.length) {
        console.log('没有要处理的图片 分支');
        return html;
      }
      // 抓取图片时间较长，通过该字段 控制其他定时接口不显示loading
      this.grabingImg = true;
      console.log(
        '将要转换的图片imgs srcs',
        imgs.map((e) => e.src)
      );
      this.transformingImgs = {
        loading: true,
        msg: `检测到${imgs.length}张新图片，正在转换...`,
      };
      // 如果向编辑器添加内容，禁止
      ueditorDocument.body.contentEditable = false;
      let data = {
        imgs: JSON.stringify(imgs.map((img) => img.src)),
        subject_id: this.$route.query.d || (await this.$refs.mediaCenter.getTempId()),
        subject_type: 2,
      };
      const postUrls = await common.myFetch(apis.grabwximg, {
        data,
        hideLoading: true,
      });
      console.log('postUrls', postUrls);
      // 让编辑器 可编辑
      ueditorDocument.body.contentEditable = true;
      let failTransformImgs = [];
      for (let img of imgs) {
        let item = postUrls.find((e) => e.original_url === img.src);
        if (item) {
          // 如果转换成功，替换src
          if (item.replace_url) {
            img.src = item.replace_url;
            // todo 话匣子添加样式修复图片超出问题
            img.style.height = 'auto';
            img.parentNode.style.maxWidth = '100%';
            img.parentNode.style.height = 'auto';
          }
          // 失败，就count,并删除图片节点
          else {
            failTransformImgs.push(img);
          }
        }
      }
      this.transformingImgs = {
        loading: false,
        msg: ``,
      };
      this.grabingImg = false;
      console.log(
        '换好后的imgs',
        imgs.map((e) => e.src)
      );
      console.log('failTransformImgs 转换失败的张数 ', failTransformImgs);
      // todo 如果有失败的，找到parentNode 删掉
      if (failTransformImgs.length) {
        this.$toast(`有${failTransformImgs.length}张图片转换失败,请稍后重试~`);
        failTransformImgs.forEach((img) => {
          img.parentNode.removeChild(img);
          img = null;
        });
      }
      console.log('grab完转换好的 fragment 外面套了一个p', fragment);
      this.$refs.mediaCenter.getFlashfile();
      return fragment.innerHTML;
    },
    /**
     * 如果当前平台包括阿基米德,要适配标签格式
     */
    filterTags(topNode, doc, operation) {
      // 先把所有的br换成\n

      let topFragment = doc.createElement('p');
      this.fragment = doc.createElement('p');
      let childNodes = [...topNode.childNodes];
      // 降维，展平
      for (let node of childNodes) {
        this.deconstructTagsWithInline(node, topFragment, operation, childNodes.length);
      }
      let temp = doc.createElement('p');
      temp.innerHTML = topFragment.innerHTML;
      console.log('appendTags前 temp', temp);
      // 层级展平之后，加到body上
      this.appendTags(topFragment, doc, operation);
      console.log('都清洗好 this.fragment', this.fragment);
      let transformedHtml = this.fragment.innerHTML;
      // 清除引用
      this.fragment = null;
      return transformedHtml;
    },

    /**
     * 如果当前平台包括阿基米德,要适配标签格式
     * 第一步，降维，将当前p下面的文字和inline-block层级变成一层
     * 把strong em i span的样式往下层带(可能有嵌套)，直到遇到文字或者媒体标签
     */
    deconstructTagsWithInline(node, parentFragment, operation, nodeLength) {
      // 如果是元素节点
      if (node.nodeType === 1) {
        // hr 标签 处理成p 带样式(toolbar也可以生成hr)
        if (node.nodeName && node.nodeName == 'HR') {
          parentFragment.appendChild(node);
        }
        // 如果是块状的容器标签
        else if (BLOCK_CONTAINER_MAP.includes(node.nodeName)) {
          parentFragment.appendChild(node);
          // 如果是音频的结构，不需要处理
          if (node.nodeName == 'IFRAME' && node.classList.contains('smg-audio')) {
            return;
          }
          // 如果是hr标签 不需要处理
          if (node.classList.contains('smghr')) return;
          // 用node.fragment来保存node层下的所有 展平的节点(原本会有多层嵌套)
          node.fragment = this.normalWindow.document.createElement('p');
          // 控制同行图文换行
          // 如果 node 带有 text-align的 style ，要往p传。
          let textAlign = node.style.textAlign;
          let marginTop = node.style.marginTop;
          let marginBottom = node.style.marginBottom;
          let lineHeight = node.style.lineHeight;
          lineHeight = lineHeight ? (lineHeight.indexOf('em') > 0 ? lineHeight.split('em')[0] * 16 + 'px' : lineHeight) : '';
          let textIndent = node.style.textIndent;

          node.fragment.textIndent = textIndent;
          node.fragment.textAlign = textAlign;
          node.fragment.marginTop = marginTop;
          node.fragment.marginBottom = marginBottom;
          node.fragment.lineHeight = lineHeight;
          let childNodes = [...node.childNodes];
          for (let node_level2 of childNodes) {
            this.deconstructTagsWithInline(node_level2, node.fragment, operation, childNodes.length);
          }
        }
        // 如果是行内的容器标签
        else if (INLINE_CONTAINER_MAP.includes(node.nodeName)) {
          let childNodes = [...node.childNodes];
          // 如果是最后清洗的话，会包括编辑过程中的 strong标签。em。span带样式
          // 得到一个 parentStyle，赋给子节点 node_level2，不断往下传到实体标签或者文字
          let style;
          if (operation === 'finalFilter') {
            // 处理当前的node。添加parentStyle属性
            style = this.deposeInlineStyle(node);
          }
          for (let node_level2 of childNodes) {
            // 给node_level2添加parentStyle
            if (JSON.stringify(style) !== '[]' && !ENTITY_MAP.includes(node_level2.nodeName)) {
              node_level2.parentStyle = style;
            }
            this.deconstructTagsWithInline(node_level2, parentFragment, operation, childNodes.length);
          }
        }
        // 如果是多媒体标签
        else if (ENTITY_MAP.includes(node.nodeName)) {
          parentFragment.appendChild(node);
        }
        // 如只有换行符，要保留。
        else if (node.nodeName === 'BR') {
          parentFragment.appendChild(node);
        }
        // 其他的 不合标准的标签 比如<br=''>，当成span标签
        else {
          console.log('进入 不合标准的标签 分支', node, node.nodeName);

          let childNodes = [...node.childNodes];
          let style;
          if (operation === 'finalFilter') {
            // 处理当前的node。添加parentStyle属性
            style = this.deposeInlineStyle(node);
          }
          for (let node_level2 of childNodes) {
            // 给node_level2添加parentStyle
            if (JSON.stringify(style) !== '[]' && !ENTITY_MAP.includes(node_level2.nodeName)) {
              node_level2.parentStyle = style;
            }
            this.deconstructTagsWithInline(node_level2, parentFragment, operation, childNodes.length);
          }
        }
      }
      // 如果是文本节点
      else if (node.nodeType === 3) {
        parentFragment.appendChild(node);
      }
    },
    brNodeType(node, count) {
      let result = '';
      // 如果前一个节点是块状
      if (BLOCK_CONTAINER_MAP.includes(node.nodeName) || node.nodeName === 'HR') {
        result = 'block';
      } else if (node.nodeName == 'BR') {
        result = 'br';
      } else if (node.nodeType === 3) {
        result = 'text';
      } else if (node.nodeName == 'IMG') {
        result = 'img';
      }
      return result;
    },
    /**
     * 第二步，遍历fragment，插入到body中
     * @param {parentFragment} 是p标签 用来包裹
     */
    appendTags(parentFragment, doc, operation) {
      // 黏贴情况下，才合并node下的文本节点。如果operation是finalFilter，可能文本node会有parentStyle样式
      if (operation === 'paste') {
        parentFragment.normalize();
      }
      // 为了BR显示效果.要知道br前面的node是什么type
      let preNodeType = 'first';
      let currentNodeType = 'first';

      // 如果p标签带text-align样式。要顺用
      let textAlign = parentFragment.textAlign;
      // 如果用toolbar给p加了text-indent。要给第一个子元素加textIndent
      let textIndent = parentFragment.textIndent;
      // 如果用toolbar给p加marginTop，给[第一个]子元素p加marginTop
      let marginTop = parentFragment.marginTop;
      // 如果用toolbar给p加marginTop，给[最后一个]子元素p加marginBottom
      let marginBottom = parentFragment.marginBottom;

      // toolbar 加 lineHeight，给[每个]子元素p加lineHeight
      let lineHeight = parentFragment.lineHeight;
      // 用来包裹文本节点和span的P。
      let outerP = doc.createElement('p');

      let childNodes = [...parentFragment.childNodes];
      let length = childNodes.length;
      let count = 0;
      // 该层 最后一个节点
      let lastNode = length ? childNodes[length - 1] : null;
      for (let node of childNodes) {
        preNodeType = currentNodeType;
        currentNodeType = this.brNodeType(node, count);
        // todo 22 可以删
        console.log('得到 currentNodeType', currentNodeType);
        // 如果是文本节点
        if (node.nodeType === 3) {
          if (count == 0) {
            if (marginTop) {
              outerP.style.marginTop = marginTop;
            }
            if (textIndent) {
              outerP.style.textIndent = textIndent.indexOf('2em') >= 0 || textIndent.indexOf('32px') >= 0 ? '32px' : 0;
            }
          }
          let span = doc.createElement('span');
          span.appendChild(node);
          // 如果有parentStyle，说明是需要包在有样式span 如underline或其他标签下 添加额外样式

          if (node.parentStyle) {
            // let span = doc.createElement("span");
            span.style.cssText = node.parentStyle.map((style) => style.replace(/;|; /g, '')).join(';');
            // span.appendChild(node);
            outerP.appendChild(span);
          } else {
            // outerP.appendChild(node);
            outerP.appendChild(span);
          }
        }
        // 媒体节点。包括图片和视频
        else if (ENTITY_MAP.includes(node.nodeName)) {
          // 遇到媒体标签一定要新建p.媒体节点不能混排
          if (outerP.childNodes.length) {
            if (textAlign) {
              outerP.style['text-align'] = textAlign;
            }
            if (lineHeight) {
              outerP.style.lineHeight = lineHeight;
            }
            this.fragment.appendChild(outerP);
            outerP = doc.createElement('p');
          }
          let p = doc.createElement('p');
          if (count == 0) {
            if (marginTop) {
              p.style.marginTop = marginTop;
            }
            if (textIndent) {
              p.style.textIndent = textIndent.indexOf('2em') >= 0 || textIndent.indexOf('32px') >= 0 ? '32px' : 0;
            }
          }
          if (textAlign) {
            p.style['text-align'] = textAlign;
          }
          if (lineHeight) {
            p.style.lineHeight = lineHeight;
          }
          // 如果是最后一个元素。包裹的p外层要加pMarginBottom
          if (count == length - 1) {
            if (marginBottom) {
              p.style.marginBottom = marginBottom;
            }
          }
          p.contentEditable = false;
          p.appendChild(node);
          this.fragment.appendChild(p);
        } else if (node.classList.contains('smg-audio') && node.nodeName == 'IFRAME') {
          if (outerP.childNodes.length) {
            if (textAlign) {
              outerP.style['text-align'] = textAlign;
            }
            if (lineHeight) {
              outerP.style.lineHeight = lineHeight;
            }
            this.fragment.appendChild(outerP);
            outerP = doc.createElement('p');
          }
          let p = doc.createElement('p');
          // todo iframe的样式。如果是第一个 。marginTop
          if (count == 0 && marginTop) {
            p.style.marginTop = marginTop;
          }
          if (lineHeight) {
            p.style.lineHeight = lineHeight;
          }
          // 如果是最后一个元素。包裹的p外层要加pMarginBottom
          if (count == length - 1 && marginBottom) {
            p.style.marginBottom = marginBottom;
          }
          p.appendChild(node);
          this.fragment.appendChild(p);
        }
        // todo 看是否判断是最后一个p 加pMarginBottom
        // todo 看是否判断是每一个p 加lineheight
        else if (node.classList.contains('smghr')) {
          if (outerP.childNodes.length) {
            if (textAlign) {
              outerP.style['text-align'] = textAlign;
            }
            if (lineHeight) {
              outerP.style.lineHeight = lineHeight;
            }
            this.fragment.appendChild(outerP);
            outerP = doc.createElement('p');
          }
          // 去掉自动生成的br
          for (let child of node.childNodes) {
            if (child.nodeName && child.nodeName === 'BR') {
              child.parentNode.removeChild(child);
              child = null;
            }
          }
          this.fragment.appendChild(node);
        }
        // BR节点
        // todo 22 样式
        else if (node.nodeName === 'BR') {
          let previousNodeType = count == 0 ? 'first' : preNodeType;
          let result = this.deposeBR({
            outerP,
            doc,
            count,
            length,
            marginTop,
            marginBottom,
            lineHeight,
            textAlign,
            textIndent,
            node,
            previousNodeType,
          });
          if (result) {
            outerP = result;
          }
        }
        // 用p伪装成hr的样子
        // hr不是 太要紧 顺延样式
        // todo 看是否判断是最后一个p 加pMarginBottom
        else if (node.nodeName === 'HR') {
          if (outerP.childNodes.length) {
            if (textAlign) {
              outerP.style['text-align'] = textAlign;
            }
            if (lineHeight) {
              outerP.style.lineHeight = lineHeight;
            }
            this.fragment.appendChild(outerP);
            outerP = doc.createElement('p');
          }
          let p = doc.createElement('p');
          p.style = `border-top: 1px solid #9A9A9A;overflow: hidden;height: 0;`;
          p.classList.add('smghr');
          p.contentEditable = false;
          this.fragment.appendChild(p);
        }
        // 如果是块状的容器标签
        else if (node.fragment) {
          // 如果遇到了块状节点。如果outerP不为空，就要让之前的outerP append到body上，不然这些文本节点会一起合并到最后，再append
          if (outerP.childNodes.length) {
            if (textAlign) {
              outerP.style['text-align'] = textAlign;
            }
            if (lineHeight) {
              outerP.style.lineHeight = lineHeight;
            }
            this.fragment.appendChild(outerP);
            outerP = doc.createElement('p');
          }
          if (count == 0) {
            if (marginTop) {
              node.fragment.marginTop = parseInt(marginTop) + parseInt(node.fragment.marginTop);
            }
          }
          // 如果本身有textIndent。不取父级的。不叠加
          if (textIndent && node.fragment.textIndent == '') {
            node.fragment.textIndent = textIndent;
          }
          if (count == length - 1 && marginBottom) {
            node.fragment.marginBottom = parseInt(marginBottom) + parseInt(node.fragment.marginBottom || 0);
          }
          if (lineHeight) {
            node.fragment.lineHeight = lineHeight;
          }
          // 如果本身有textIndent。不取父级的。不叠加
          if (textAlign && node.fragment.textAlign == '') {
            node.fragment.textAlign = textAlign;
          }
          // 再去遍历他的内容，添加到body上
          this.appendTags(node.fragment, doc);
        }
        count++;
      }
      // 如果最后一个节点是文本节点,将outerP添加到fragement上
      if (lastNode && lastNode.nodeType === 3) {
        if (textAlign) {
          outerP.style['text-align'] = textAlign;
        }
        if (lineHeight) {
          outerP.style.lineHeight = lineHeight;
        }
        if (marginBottom) {
          outerP.style.marginBottom = marginBottom;
        }
        this.fragment.appendChild(outerP);
      }
    },

    // 阿基米德 处理BR标签
    /**
     * 注意点：
     * 1. 如果 previousSibling 为空/ 或者previousSibling 是块状节点。就 加一个空P
     * 2. 前面是文本节点，就让outerP append。
     * 3. 前面是img 节点，就让什么也不做
     * 4. 前面是br节点。就添加一个空p
     * todo 考虑 如果以伪装的标签
     */
    deposeBR({ outerP, doc, count, length, marginTop, marginBottom, lineHeight, textAlign, textIndent, node, previousNodeType }) {
      console.log('deposeBR中 previousNodeType', previousNodeType);
      console.log('deposeBR count', count);
      // 如果没有前节点。
      if (previousNodeType == 'first') {
        let p = doc.createElement('p');
        if (count == length - 1 && marginBottom) {
          p.style.marginBottom = marginBottom;
        }
        if (marginTop) {
          p.style.marginTop = marginTop;
        }
        if (textIndent) {
          p.style.textIndent = textIndent.indexOf('2em') >= 0 || textIndent.indexOf('32px') >= 0 ? '32px' : 0;
        }
        if (lineHeight) {
          p.style.lineHeight = lineHeight;
        }
        if (textAlign) {
          p.style['text-align'] = textAlign;
        }

        p.style['min-height'] = '14px';

        this.fragment.appendChild(p);
      }
      // 如果是块状节点
      else if (previousNodeType == 'block' || previousNodeType == 'br') {
        let p = doc.createElement('p');
        if (count == length - 1 && marginBottom) {
          p.style.marginBottom = marginBottom;
        }
        if (lineHeight) {
          p.style.lineHeight = lineHeight;
        }
        if (textAlign) {
          p.style['text-align'] = textAlign;
        }
        p.style['min-height'] = '14px';
        this.fragment.appendChild(p);
      }
      // 如果前面是文本节点
      else if (previousNodeType === 'text') {
        // 之前的要append到body上
        if (outerP.childNodes.length) {
          if (textAlign) {
            outerP.style['text-align'] = textAlign;
          }
          if (lineHeight) {
            outerP.style.lineHeight = lineHeight;
          }
          if (count == length - 1 && marginBottom) {
            outerP.style.marginBottom = marginBottom;
          }
          this.fragment.appendChild(outerP);
          return (outerP = doc.createElement('p'));
        }
      }
      // 如果是img节点
      else if (previousNodeType == 'img') {
      }
    },
    /***
     * 适配阿基米德
     * 如果是最后清洗的话，会包括编辑过程中的 strong标签。em。span带样式
     * todo 行内文本可以只留限定样式 font-size/font-weight/text-decoration/color/background-color/text-align/border
     */
    deposeInlineStyle(node) {
      // parentStyle 从上层传下来的样式
      let parentStyle = node.parentStyle || [];
      // currentStyle 当前节点node的样式
      let currentStyle = (node.style.cssText && node.style.cssText.replace(/; /g, ';')).replace(/: /g, ':') || '';
      currentStyle = currentStyle.split(';') || [];
      let styleObj = {};
      if (parentStyle && parentStyle.length) {
        // 当前的style优先级更高
        //  遍历，如果已经出现过，那么就以currentStyle里的优先
        parentStyle.forEach((e) => {
          if (!e) return;
          let item = e.split(':');
          let key = item && item[0] && item[0].trim();
          let value = item && item[1] && item[1].trim();
          styleObj[key] = value;
        });
      }
      // 当前的style优先级更高
      currentStyle.forEach((e) => {
        if (!e) return;
        let item = e.split(':');
        let key = item && item[0] && item[0].trim();
        let value = item && item[1] && item[1].trim();
        // 如果这个样式在父节点也出现，那么以current优先
        styleObj[key] = value;
      });
      // 标签自带的样式，添加到末尾
      if (node.nodeName == 'STRONG' || node.nodeName == 'B') {
        styleObj['font-weight'] = 'bold';
      } else if (['EM', 'I'].includes(node.nodeName)) {
        styleObj['font-style'] = 'italic';
      } else if (['U'].includes(node.nodeName)) {
        styleObj['text-decoration'] = 'underline';
      }
      // 去掉行内的带margin的样式
      return Object.keys(styleObj)
        .filter((key) => key.indexOf('margin') < 0)
        .map((key) => `${key}:${styleObj[key]}`);
    },
    foldClues() {
      this.showClue = !this.showClue;
      this.$refs.mediaCenter.folding = !this.showClue;
    },
    addHrefId(id) {
      // 获取到id后添加到url上
      if (window.location.href.indexOf("d=") < 0) {
        if (window.location.href.indexOf("?") < 0) {
          // window.location.href += `?d=${id}`;
          this.$router.push(window.location.pathname + `?d=${id}`)
        } else {
          // window.location.href += `&d=${id}`;
          const i = window.location.href.indexOf("?")
          const t = window.location.href.substring(i)
          this.$router.push(window.location.pathname + t + `&d=${id}`)
        }
      }
    },
    getTempId() {
      // 获取报道／线索 临时id
      const info = {
        submit_act: 'upload',
        depart_id: this.select.depart.id,
        depart_title: this.select.depart.text,
      };

      return common.myFetch(apis.publish_edit, info).then((r) => {
        if (r) {
          const id = r.id;
          this.tmpId = id;
          this.addHrefId(id);

          return id;
        }
      });
    },
    async compositeAudio() {
      // 合成音频
      const title = this.global.title;
      const tvContent = `[正文]${this.tvText.body}[导语]${this.tvText.lead}[编后]${this.tvText.after}`;
      const sportContent = `[导语]${this.tvText.lead}[正文]${this.tvText.body}[编后]${this.tvText.after}`;
      let content = this.normalContent;

      if (this.selectedType.id == 1) {
        content = tvContent;
      } else if (this.selectedType.id == 2) {
        content = this.radioText;
      } else if (this.selectedType.id == 4) {
        content = sportContent;
      }

      if (!title) {
        this.$toast('请填写标题');
        return;
      }

      // if (!content) {
      //   this.$toast('请填写正文')
      //   return
      // }

      let id = this.$route.query.d || this.tmpId;
      if (!id) {
        id = await this.getTempId();
      }

      this.audioComposeConfig.title = this.global.title;
      this.audioComposeConfig.article = content;
      this.audioComposeConfig.page_type = 'publish';
      this.audioComposeConfig.page_id = this.$route.query.d;
      this.audioComposeConfig.makeup_audio_version = this.global.makeup_audio_version;

      this.$refs.audioCompose.open(this.audioComposeConfig);
    },
    getUploadConfig(r) {
      // 获取上传参数
      this.audioComposeConfig.target = r.pickuptext_path;
      this.audioComposeConfig.app_id = common.hex2str(r.pickuptext_id);
      this.audioComposeConfig.app_secret = common.hex2str(r.pickuptext_secret);
      this.audioComposeConfig.host = common.hex2str(r.pickuptext_host);
      console.log('接收上传参数', r, this.audioComposeConfig);
    },
    /**
     * 送审
     */
    async toCheck() {
      if (this.uploading) return;

      if (this.global.column_info.length === 0) {
        this.$toast('发布平台不可为空');
        return;
      }

      this.uploading = true;
      this.showNoToast = true;
      this.postData('sub').then((r) => {
        if (r) {
          this.$toast('操作成功');

          setTimeout(() => {
            window.removeEventListener('beforeunload', this.beforeunload_normal);
            window.removeEventListener('beforeunload', this.beforeunload_akmd);
            window.close();
          }, 1000);
        } else {
          this.uploading = false;
        }
      });
    },
    getInsert(dom) {
      console.log('进入 getInsert', dom);
      // 接收插入稿件数据
      if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        // this.tvContent = this.tvContent + dom
        if (dom.type === 'img') {
          this.tvInstance.execCommand(
            'inserthtml',
            this.hasAKMD
              ? `<p contentEditable='false'><img src="${dom.url}" style="max-width: calc(100vw); height: auto;"/></p>`
              : `<img src="${dom.url}" style="max-width: calc(100vw); height: auto;"/>`
          );
          setTimeout(() => {
            let height = document.getElementById('edui1_iframeholder').getBoundingClientRect().height + document.getElementsByClassName(newClass)[0].getBoundingClientRect().height;
            document.getElementById('edui1_iframeholder').style.height = height + 'px';
          }, 1000);
        } else if (dom.type === 'video') {
          this.tvInstance.execCommand(
            'inserthtml',
            `<p style='text-align:center;'><video src="${dom.url}" style="max-width: calc(100vw); height: auto;" controls  poster="${dom.cover}" controlsList="nodownload" /></p>`
          );
        } else if (dom.type === 'audio') {
          let audio = document.createElement('AUDIO');
          audio.src = dom.url;
          audio.oncanplay = () => {
            let duration = audio.duration.toFixed();
            let h = parseInt(duration / 60 / 60);
            let m = parseInt((duration / 60) % 60);
            let s = duration - h * 60 * 60 - m * 60;
            console.log('oncanplay duration', h, m, s);
            this.normalInstance.execCommand(
              'inserthtml',
              `<p></p><iframe class="smg-audio" frameborder="0" width="100%" height="80" _src="${dom.url}" src="${window.location.origin}/static/xnsaudio/audio.html?is=${dom.idstring}" allowFullScreen="false"></iframe><p></p>`
            );
          };
        }
      } else {
        if (dom.type === 'img') {
          let newClass = 'p' + +new Date();
          this.normalInstance.execCommand(
            'inserthtml',
            this.hasAKMD
              ? `<p contentEditable='false'><img src="${dom.url}" style="max-width: calc(100vw); height: auto;"/></p>`
              : `<img src="${dom.url}" style="max-width: calc(100vw); height: auto;"/>`
          );
          setTimeout(() => {
            let height = document.getElementById('edui1_iframeholder').getBoundingClientRect().height + document.getElementsByClassName(newClass)[0].getBoundingClientRect().height;
            document.getElementById('edui1_iframeholder').style.height = height + 'px';
          }, 1000);
        } else if (dom.type === 'video') {
          this.normalInstance.execCommand(
            'inserthtml',
            `<p style='text-align:center;'><video src="${dom.url}" style="max-width: calc(71vw); height: auto;" controls poster="${dom.cover}" controlsList="nodownload">video</video></p>`
          );
        } else if (dom.type === 'audio') {
          let audio = document.createElement('AUDIO');
          audio.src = dom.url;
          audio.oncanplay = () => {
            let duration = audio.duration.toFixed();
            let h = parseInt(duration / 60 / 60);
            let m = parseInt((duration / 60) % 60);
            let s = duration - h * 60 * 60 - m * 60;
            console.log('oncanplay duration', h, m, s);
            this.normalInstance.execCommand(
              'inserthtml',
              `<p></p><iframe class="smg-audio" frameborder="0" width="100%" height="80" _src="${dom.url}" src="${window.location.origin}/static/xnsaudio/audio.html?is=${dom.idstring}" allowFullScreen="false"></iframe><p></p>`
            );
          };
        }
      }
    },
    getPid(id) {
      // 获取临时id
      this.tmpId = id;
    },
    addTag() {
      if (!this.tag) return;

      if (this.tag.length > 8) {
        this.$toast('标签字数不能超过8个');
        return;
      }

      const allTags = this.global.tags || [];
      if (allTags.filter((i) => i === this.tag).length > 0) {
        this.$toast('请勿重复添加');
        this.tag = '';
        return;
      }

      this.global.tags.push(this.tag);
      this.tag = '';
    },
    generateTag() {
      // 根据内容生成标签
      const tvContent = `[正文]${this.tvText.body}[导语]${this.tvText.lead}[编后]${this.tvText.after}`;
      let content = this.normalContent;

      if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        content = tvContent;
      } else if (this.selectedType.id == 2) {
        content = this.radioText;
      }

      const contentData = common.escapeEscapes(common.cleanHtmlTags(content));

      const info = {
        content: contentData,
        topnum: 5,
      };

      common.myFetch(apis.split_words, info).then((r) => {
        if (r) {
          const arrObj = {};
          r.forEach((i) => {
            arrObj[i] = 'a';
          });

          this.global.tags.forEach((j) => {
            if (arrObj.hasOwnProperty(j)) {
              arrObj[j] = 'd';
            }
          });

          const res = [];

          for (const k in arrObj) {
            if (arrObj[k] === 'a') {
              res.push(k);
            }
          }

          console.log('123212', arrObj, res);
          this.global.tags = this.global.tags.concat(res);
        }
      });
    },
    deleteTag(i) {
      this.global.tags.forEach((j, ji) => {
        if (i === j) {
          this.global.tags.splice(ji, 1);
        }
      });
    },
    deleteItv(i) {
      // 删除关联采访
      this.withInterview = {};
    },
    deleteRpt() {
      // 删除关联报道
      this.withReport = {};
    },
    deleteTpc(t) {
      // 删除关联选题
      this.withTopic = {};
    },
    deleteClue(clue) {
      // 删除关联线索
      this.global.materials.forEach((i, d) => {
        if (clue.material_id === i.material_id) {
          this.global.materials.splice(d, 1);
        }
      });
    },
    addClue() {
      const materials = this.global.materials;

      this.$refs.withClue.open(materials);
    },
    openWith(key) {
      this.$refs[key].open();
    },
    openWithReport() {
      // 打开关联报道弹窗
      this.$refs.withReport.open(this.withReport);
    },
    fetchTopic(t) {
      // 获取关联选题
      this.withTopic = t;
    },
    fetchInterview(i) {
      // 获取关联采访
      this.withInterview = i;
    },
    fetchClue(res) {
      // 获取关联线索
      const cluesBefore = this.global.materials.map((i) => i.material_id);
      const clues = [];
      res.forEach((i) => {
        if (cluesBefore.indexOf(i.material_id) < 0) {
          clues.push(i);
        }
      });

      this.withClues = res;
      this.$set(this.global, 'materials', this.withClues);
      if (res.length === 0) return;

      const title = (clues[0] || {}).title || '';
      let content = '';
      let body = '';
      let lead = '';
      let after = '';
      let reporter = '';
      let video = '';

      clues.forEach((i) => {
        if (i.type == 0) {
          content += i.content;
          body += i.content;
        } else {
          const contentBody = common.getBody(i.content); // 当被关联的电视稿内容格式有问题时（包括了无内容），将其全部内容放到正文中
          if (!contentBody) {
            content += i.content;
            body += i.content;
          } else {
            content += i.content;
            body += common.getBody(i.content);
            lead += common.getLead(i.content);
            after += common.getAfter(i.content);
            reporter += common.getReporterText(i.content);
            video += common.getVideoText(i.content);
          }
        }
      });

      // 关联线索时，如何处理策划、采访、标签？（待处理）

      if (clues.length === 0) return; //如果没有新选择的线索，则不操作

      const contentData = {
        content: content,
        body: body,
        lead: lead,
        after: after,
        reporter: reporter,
        video: video,
      };

      this.combinePage(title, contentData, false);

      const mids = clues.map((i) => i.material_id).join(',');
      if (!mids) return;
      this.copyClueFiles(mids);
    },

    fetchReport(r) {
      console.log('report', r);
      this.withReport = r;
    },
    getPublishPlatform() {
      let info = {};
      info['depart_id'] = this.select.depart.id;
      info['type'] = this.$route.query.t;
      return common.myFetch(apis.publish_platform, info).then((res) => {
        console.log(res);
        return res.push_list;
      });
    },
    async openPublishPlat() {
      // 打开发布平台弹窗
      console.log('已选平台');
      if (this.select.depart.text && this.select.depart.id) {
        let list = [];
        // this.global.depart_list.forEach((el) => {
        //   if(el.id==this.select.depart.id&&el.title==this.select.depart.text){
        //     list = el.push_list
        //   }
        // })
        let i = await this.getPublishPlatform();
        list = i;
        const s = '';
        const platformData = {
          publishId: this.$route.query.d,
          selected: this.global.column_info || [],
          list: list,
          // list: this.global.push_list
        };
        this.$refs.publishPlatforms.open(platformData);
      } else {
        this.$toast('请先选择部门');
      }
    },
    deletePlatform(t) {
      // 删除已选平台
      this.global.column_info.forEach((o, i) => {
        if (t.fid == o.fid) {
          if (t.sid == o.sid) {
            if (t.tid) {
              if (t.tid == o.tid) {
                this.global.column_info.splice(i, 1);
              }
            } else {
              this.global.column_info.splice(i, 1);
            }
          }
        }
      });

      console.log('selected platforms', this.global.column_info);
    },
    getSelected(s) {
      this.global.column_info = s;
      console.log('获取已选平台', this.global.column_info);
    },
    clearPlatforms() {
      // 清空已选发布平台
      this.global.column_info = [];
    },
    goClue(id) {
      common.jump(`/clueDetail?d=${id}`, true);
    },
    getData() {
      // 获取数据
      let info = {};
      const t = this.$route.query.t;

      if (!this.isNew) {
        info['id'] = this.$route.query.d;
        this.pageId = this.$route.query.d;
      }

      if (this.$route.query.t) {
        // console.log(999)
        info['type'] = this.$route.query.t;
      } else {
        info['type'] = '';
      }

      return common.myFetch(apis.publish_editinfo, info).then(async (res) => {
        if (res) {
          await this.getAIEditAuth();
          this.hasInitAIAuth = true;
          this.global = res.detail;
          console.log('aiEditAuth', this.aiEditAuth);

          console.log('getdata global', this.global);
          if (this.global.cover != '' && this.global.cover != undefined && this.global.cover != null && this.global.cover != 'undefined') {
            this.cover = this.global.cover;
          } else {
            this.cover = '';
          }

          if (this.cover) {
            this.hasCover = true;
          } else {
            this.hasCover = false;
          }
          // 是否进入页面前，就发布平台就包含阿基米德了
          this.preChosenAKMD = (this.global.column_info && this.global.column_info.some((e) => e.ftitle === '阿基米德')) || false;
          this.saveWord = this.global.title;

          if (res.detail.depart_list && res.detail.depart_list.length > 0) {
            if (res.detail.depart_id) {
              res.detail.depart_list.forEach((el) => {
                if (el.id == res.detail.depart_id) {
                  this.select.depart.text = el.title;
                  this.select.depart.id = el.id;
                  this.select.depart.has_release = el.has_release;
                  this.select.depart.has_verify = el.has_verify;
                }
              });
            } else {
              this.select.depart.text = res.detail.depart_list[0].title;
              this.select.depart.id = res.detail.depart_list[0].id;
              this.select.depart.has_release = res.detail.depart_list[0].has_release;
              this.select.depart.has_verify = res.detail.depart_list[0].has_verify;
            }
          }

          if (this.global.author == '' || this.global.author == undefined || this.global.author == null) {
            this.getUser();
          }

          this.speed = this.global.content_speed || 330;
          this.$set(
            this.global,
            'tags',
            this.global.tags.map((i) => i.title || i)
          );
          await this.autoSelected();
          this.getDC();

          if (this.global.content_category && this.global.content_category.length > 0) {
            this.content_category = this.global.content_category;
            // this.content_category.forEach(el => {
            //   el.selected = false;
            //   el.hide = false;
            // })
          }

          if (this.global.iview_id != 0) {
            this.fetchInterview({
              id: this.global.iview_id,
              title: this.global.iview_title,
            });
          }
          if (this.global.topic_id != 0) {
            this.fetchTopic({
              id: this.global.topic_id,
              title: this.global.topic_title,
            });
          }
          if (this.global.report_id != 0) {
            this.fetchReport({
              id: this.global.report_id,
              title: this.global.report_title,
            });
          }

          if (this.global.content_category_ids) {
            console.log(12);
            this.content_category_ids = [];
            this.global.content_category.forEach((el, index2) => {
              console.log(el);
              if (el.selected) {
                this.content_category_index = index2;
                el.son_list.forEach((val) => {
                  if (val.selected) {
                    val.parentName = el.name;
                    val.parentId = el.id;
                    console.log(val);
                    this.content_category_ids.push(val);
                  }
                });
              }
            });

            console.log(this.content_category_ids);
            // let content_category_ids = this.global.content_category_ids.split(',')
            // console.log(content_category_ids,this.content_category)
            // content_category_ids.forEach(el => {
            //   this.content_category.forEach(item => {
            //     if(el == item.id){
            //       console.log(el)
            //       item.selected = true
            //       item.parentId = el.id
            //       item.parentName = el.name
            //       this.content_category_ids.push(item)
            //     }
            //   })
            // })
          }

          this.mediaData = {
            img: this.global.img_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            audio: this.global.sound_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            video: this.global.video_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            file: this.global.file_list.map((i) => {
              i.name = i.title;
              return i;
            }),
          };

          if (this.global.leading_creator) {
            this.leading_creator = this.global.leading_creator;
          }

          if (this.global.edit_date && this.global.edit_date != '0000-00-00 00:00:00') {
            this.edit_date = new Date(this.global.edit_date);
          }

          if (this.global.is_sensitive && this.global.is_sensitive.length > 0) {
            this.global.is_sensitive.forEach((el) => {
              if (el.selected) {
                this.is_sensitive = el.id;
              }
            });
          }

          if (this.global.is_good && this.global.is_good.length > 0) {
            this.global.is_good.forEach((el) => {
              if (el.selected) {
                this.is_good = el.id;
              }
            });
          }

          if (this.global.leader && this.global.leader.length > 0) {
            this.global.leader.forEach((el) => {
              if (el.selected) {
                this.leader = el.id;
              }
            });
          }

          if (this.global.field && this.global.field.length > 0) {
            this.global.field.forEach((el) => {
              if (el.selected) {
                this.field = el.id;
              }
            });
          }

          this.person = this.global.person;

          this.project = this.global.project;

          this.tipsContent = this.global.info;

          this.type_tag_ids = this.global.type_tag_ids;

          let tagArr = [];

          if (this.global.type_tag && this.global.type_tag.length > 0) {
            this.global.type_tag.forEach((el) => {
              el.son_list.forEach((val) => {
                if (val.selected) {
                  tagArr.push(val.name);
                }
              });
            });
          }

          if (this.tipsContent && this.tipsContent.length > 0) {
            this.showTips = false;
          }

          tagArr = tagArr.join(',');

          this.type_tag_name = tagArr;

          return res.detail;
        }
      });
    },
    getDC() {
      // 获取环境中关联的采访和线索
      const interview = dc.getItv() || {};

      this.withInterview = this.withInterview.id ? this.withInterview : interview;
    },
    async combinePage(title, content) {
      console.log('combinePage');
      // 将线索内容插入到稿件中
      const type = this.selectedType.id;
      this.global.title = this.global.title || title;

      if (type == 1 || type == 4) {
        this.insertTVContent(content.body, '[正文]');
        this.insertTVContent(content.lead, '[导语]');
        this.insertTVContent(content.after, '[编后]');

        if (!content.body && !content.lead && !content.after) {
          let contentBody = common.replaceBr2N(content.content);

          this.insertTVContent(contentBody, '[正文]');
        }
      } else if (type == 2) {
        this.$refs.radioTextBody.innerHTML = content.content;
      } else {
        console.log('type不为1', content.content);
        this.normalContent = this.normalContent + common.replaceN2Br(content.content);
      }
    },
    insertTVContent(content, spliter) {
      // 将指定部分内容插入到电视稿中, 推送过来直接放置，关联则新增
      content = common.replaceTags(content); // 将内容中的[正文/导语/编后]转为【正文/导语/编后】
      content = common.cleanHtml(content);

      let tv = this.global.content;
      tv = common.replaceBr2N(tv);
      const body = common.getBody(tv) || this.tvText.body;
      const lead = common.getLead(tv) || this.tvText.lead;
      const after = common.getAfter(tv) || this.tvText.after;

      if (spliter == '[正文]') {
        this.tvText.body = body + content;
        this.$refs.tvTextBody.innerText = body + content;
      } else if (spliter == '[导语]') {
        this.tvText.lead = lead + content;
        this.$refs.tvTextLead.innerText = lead + content;
      } else if (spliter == '[编后]') {
        this.tvText.after = after + content;
        this.$refs.tvTextAfter.innerText = after + content;
      }
    },
    async copyClueFiles(mid) {
      // 将线索文件复制到报道上
      let id = this.$route.query.d || this.tmpId;
      if (!id) {
        id = await this.postData('save');
      }

      const create_from = this.$route.query.push ? 1 : 0;
      const info = {
        mid: mid,
        publish_id: id,
        create_from: create_from,
      };
      this.uploading = true;

      common.myFetch(apis.publish_withClueFile, { data: info, hideLoading: true }).then((r) => {
        if (r) {
          if (r.publish_id) {
            this.addHrefId(r.publish_id);
          }

          this.mediaData = {
            img: r.img_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            audio: r.sound_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            video: r.video_list.map((i) => {
              i.name = i.title;
              return i;
            }),
            file: r.file_list.map((i) => {
              i.name = i.title;
              return i;
            }),
          };
          this.uploading = false;
          // 复制素材后进行保存
          if (this.saveAfterCopyclues) {
            this.showNoToast = true;
            this.saveAndJump('save');
          }
        }
      });
    },
    autoSelected() {
      if (!this.isNew) {
        this.selectedType.id = this.global.type;
        this.canInsert = this.selectedType.id != 1 && this.selectedType.id != 2 && this.selectedType.id != 4;
      }
      // 根据数据渲染内容
      // 新媒体稿
      if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        // console.log('type为0 新媒体稿',)
        this.normalContent = common.replaceN2Br(this.global.content);

        this.$nextTick(() => {
          // 将新媒体稿编辑器内容中的xnsaudio替换为自定义
          common.formatXNSAudios(this.normalWindow.document);

          this.$nextTick(() => {
            setTimeout(() => {
              const _hiddenNormal = document.querySelector('._hiddenNormal');
              const _hiddenNormalHeight = window.getComputedStyle(_hiddenNormal, null).getPropertyValue('height');

              if (parseInt(this.normalInstance.iframe.parentNode.style.height) >= parseInt(_hiddenNormalHeight)) return;

              this.normalInstance.iframe.parentNode.style.height = _hiddenNormalHeight;
            }, 1000);

            this.calculateText();
          });
        });
      }
      // 电视稿
      else if (this.selectedType.id == 1) {
        // console.log('type为1 电视稿', 1)
        let tv = this.global.content;
        tv = common.replaceBr2N(tv);
        let body = common.getBody(tv);
        let lead = common.getLead(tv);
        let after = common.getAfter(tv);
        body = common.replaceTags(body);
        lead = common.replaceTags(lead);
        after = common.replaceTags(after);

        setTimeout(() => {
          this.$refs.tvTextBody.innerText = body;
          this.$refs.tvTextLead.innerText = lead;
          this.$refs.tvTextAfter.innerText = after;
          this.tvText = {
            body: body,
            lead: lead,
            after: after,
          };
          this.bodyFocus();
        }, 0);
      } else if (this.selectedType.id == 4) {
        // console.log('type为1 电视稿', 1)
        let tv = this.global.content;
        tv = common.replaceBr2N(tv);
        let body = common.getBody1(tv);
        let lead = common.getLead1(tv);
        let after = common.getAfter1(tv);
        body = common.replaceTags(body);
        lead = common.replaceTags(lead);
        after = common.replaceTags(after);

        setTimeout(() => {
          this.$refs.tvTextBody.innerText = body;
          this.$refs.tvTextLead.innerText = lead;
          this.$refs.tvTextAfter.innerText = after;
          this.tvText = {
            body: body,
            lead: lead,
            after: after,
          };
          this.bodyFocus();
        }, 0);
      } else if (this.selectedType.id == 2) {
        let radio = this.global.content;
        radio = common.replaceBr2N(radio);
        radio = common.replaceTags(radio);
        this.$refs.radioTextBody.innerText = radio;
        this.radioText = radio;
      }

      this.$nextTick(() => {
        common.handlePageMediaCenterPosition();
      });
    },
    bodyFocus() {
      // 将焦点定位到正文输入框中并且位于文字之后
      const bodyDom = this.$refs.tvTextBody;
      bodyDom.focus();

      // if (window.getSelection) {
      //   const selection = window.getSelection()
      //   const range = document.createRange()
      //   const n = this.tvText.body.length
      //
      //   range.setStart(bodyDom.firstChild, n)
      //   range.selectNode(bodyDom)
      //   selection.removeAllRanges()
      //   selection.addRange(range)
      // }
    },
    async saveAndJump(status) {
      if (this.uploading) return;

      this.uploading = true;

      this.postData(status).then((r) => {
        if (r) {
          if (status === 'save') {
            this.uploading = false;
            window.removeEventListener('beforeunload', this.beforeunload_normal);
            return;
          }
          // 修改
          window.removeEventListener('beforeunload', this.beforeunload_normal);
          window.removeEventListener('beforeunload', this.beforeunload_akmd);
          window.close();
        } else {
          this.uploading = false;
        }
      });
    },
    async saveAndApprove() {
      // 修改并通过
      if (this.uploading) return;

      this.uploading = true;
      const id = this.$route.query.d || this.tmpId;
      const postDataFetch = await this.postData('modify');
      let verifyFetch = null;

      if (postDataFetch) {
        const info = {
          id: id,
          status: 0,
        };

        verifyFetch = await common.myFetch(apis.publishVerify, info);

        if (verifyFetch) {
          window.removeEventListener('beforeunload', this.beforeunload_normal);
          window.removeEventListener('beforeunload', this.beforeunload_akmd);
          window.close();
        } else {
          this.uploading = false;
        }
      } else {
        this.uploading = false;
      }
    },
    async releaseAndJump(status) {
      if (this.uploading) return;

      if (this.global.column_info.length === 0) {
        this.$toast('发布平台不可为空');
        return;
      }

      this.uploading = true;
      // todo

      const id = await this.postData(status);

      if (id) {
        this.publish(id).then((r) => {
          if (r) {
            window.removeEventListener('beforeunload', this.beforeunload_normal);
            window.removeEventListener('beforeunload', this.beforeunload_akmd);

            const info = {
              msg: r.msg_one,
              tip: r.msg_two || '页面即将关闭',
            };

            this.$refs.successTip.open(info);
          } else {
            this.uploading = false;
          }
        });
      } else {
        this.uploading = false;
      }
    },
    async publish(id) {
      // const pushIds = this.pushIds === 'cancel' ? await this.$refs.pushBox.open(id) : this.pushIds
      // if (pushIds === 'cancel') {
      //   this.uploading = false
      //   return
      // }

      const info = {
        id: id,
        // push_id: pushIds
      };

      return common.myFetch(apis.publish_publish, info).then((res) => {
        return res;
      });
    },
    /**
     * auto 是自动保存
     */
    async postData(status, hint) {
      // 提交数据
      let content = '';
      // let isEmpty = false
      // 电视稿
      if (this.selectedType.id == 1) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);
        content = `[正文]${body}[导语]${lead}[编后]${after}`;
      }
      // 体育稿
      else if (this.selectedType.id == 4) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);
        content = `[导语]${lead}[正文]${body}[编后]${after}`;
      }
      // 新媒体稿
      else if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        content = this.normalContent.replace(/\<mark\>/g, '').replace(/\<\/mark\>/g, '');
        // 需要把 智能写稿的 临时加的 模拟选区的highlight 标签去掉
        content = this.deposeOptimizeHightlight(content);
      }
      // 广播稿
      else if (this.selectedType.id == 2) {
        content = common.replaceTags(this.radioText);
      }

      // 如果当前平台包括阿基米德,且是上传操作，就要最后再清洗一遍标签，再上传
      if (this.hasAKMD && (this.selectedType.id == 0 || this.selectedType.id == 3) && ['release', 'auto', 'save', 'sub', 'modify'].includes(status)) {
        content = this.finalFilter(content, 'postdata');
        // console.log('清洗完 content', content);
      }
      // if (this.uploading && status !== 'save' && status !== 'auto') return  //上传时禁止提交（保存草稿和自动保存例外）
      const allTags = this.global.tags.join(',');
      let id = this.$route.query.d || this.tmpId;
      let content_category_ids = [];
      this.content_category_ids.forEach((el) => {
        if (el.selected) {
          content_category_ids.push(el.id);
          content_category_ids.push(el.parentId);
        }
      });
      content_category_ids = content_category_ids.join(',');

      let edit_date = '';
      console.log(this.edit_date);
      if (this.edit_date) {
        edit_date = common.stampToTime(this.edit_date);
      } else {
        edit_date = '';
      }
      const data = {
        title: this.global.title,
        content: content,
        type: this.selectedType.id,
        submit_act: status,
        st_id: this.withTopic.id || '',
        iview_id: this.withInterview.id || '',
        tags: allTags,
        mid: this.global.materials.map((j) => j.material_id).join(','),
        report_id: this.withReport.id || '',
        id: id,
        content_speed: this.speed,
        column_info: JSON.stringify(this.global.column_info),
        depart_id: this.select.depart.id,
        depart_title: this.select.depart.text,
        author: this.global.author,
        source: this.global.source,
        cover: this.cover,
        content_category_ids: content_category_ids,
        edit_date: edit_date,
        is_sensitive: this.is_sensitive,
        is_good: this.is_good,
        project: this.project,
        person: this.person,
        field: this.field,
        leader: this.leader,
        leading_creator: this.leading_creator,
        type_tag_ids: this.type_tag_ids,
        info: this.tipsContent || '',
        editor: this.global.editor || '',
        response_editor: this.global.response_editor || '',
      };

      return common
        .myFetch(apis.publish_edit, {
          data: data,
          hideLoading: this.showNoToast || this.grabingImg,
        })
        .then((r) => {
          console.log('postdata r', r);

          // todo 预览1
          // 位置放在 if(r)里面？
          this.setInitailContent();
          // todo 预览1-新改的，重新确认自动保存
          this.setAutosave();
          if (r) {
            if (status != 'sub' && status != 'auto' && status != 'release') {
              if (!this.showNoToast) {
                this.$toast('操作成功');
              }
              this.showNoToast = false; // 如果showNoToast被设置true，则调用一次之后重置为false
            }
            this.addHrefId(r.id);

            return r.id;
          }

          return r;
        });
    },
    /**
     * 需要把 智能写稿的 维持选区 外部套的 模拟选区的 highlight span标签去掉
     */
    deposeOptimizeHightlight(content) {
      let dom = document.createElement('div');
      dom.innerHTML = content;
      let highlightElement = dom.querySelector('span.selection-highlight');
      // 如果有高亮 元素，需要 解除，还原到本文
      if (highlightElement) {
        let parent = highlightElement.parentNode;

        while (parent && highlightElement.firstChild) {
          parent.insertBefore(highlightElement.firstChild, highlightElement);
        }
        parent && parent.removeChild(highlightElement);
      }
      return dom.innerHTML;
    },
    getFold(status) {
      this.showClue = !status;
    },
    setAutosave() {
      // todo 预览1
      //  传true。需要content不为空
      const contentChanged = this.checkInitailContentChange(true);
      console.log('contentChanged', contentChanged);
      // todo ai写稿 高亮元素 hightElement 不应该算作 contentChanged。之后处理
      if (this.isDraft && contentChanged) {
        this.autoSave.interval =
          this.autoSave.interval ||
          setInterval(() => {
            // todo 需要恢复
            this.handleAutoSave();
          }, this.autoSave.time);
      } else {
        if (this.autoSave.interval) {
          clearInterval(this.autoSave.interval);
          this.autoSave.interval = null;
        }
      }
    },
    /**
     * 黏贴过滤掉音频和视频
     */
    filterVideoAndAudio(html) {
      let p = this.normalWindow.document.createElement('p');
      p.innerHTML = html;
      let videos = p.querySelectorAll('video');
      let audios = p.querySelectorAll('audio');
      videos.forEach((e) => {
        e.parentNode.removeChild(e);
        e = null;
      });
      audios.forEach((e) => {
        e.parentNode.removeChild(e);
        e = null;
      });
      return p.innerHTML;
    },
    /**
     * 移除 编辑器 黏贴时 自动加的 text-wrap-mode:nowrap 导致不换行
     */
     filterPasteNoWrap(html) {
      let p = this.normalWindow.document.createElement('p');
      p.innerHTML = html;
      let spans = p.querySelectorAll('span[style*="text-wrap-mode: nowrap"]');  
      console.log('spans',spans)
      spans.forEach((span) => {
        // 获取当前 style 并替换掉 text-wrap-mode
        const currentStyle = span.getAttribute('style');
        const newStyle = currentStyle.replace(/text-wrap-mode:\s*nowrap;?/g, '');
        console.log('移除 不换行 newStyle',newStyle)
        span.setAttribute('style', newStyle.trim());
      });
      return p.innerHTML;
    },
    /**
     * 处理外部导入稿件里的视频 没有controls无法播放问题
     */
    deposeVideo(html) {
      if (!html) return html;
      let p = this.normalWindow.document.createElement('p');
      p.innerHTML = html;
      let videos = p.querySelectorAll('video');
      videos.forEach((e) => (e.controls = true));
      return p.innerHTML;
    },
    deposeAudioSrc(html) {
      if (!html) return html;
      let p = this.normalWindow.document.createElement('p');
      p.innerHTML = html;
      let audios = p.querySelectorAll('audio');
      audios.forEach((audio) => {
        let _src = audio.dataset.src;
        console.log('deposeAudioSrc _src', _src);
        if (_src) {
          audio.src = _src;
        }
        common.replaceXNSAudios1(audio);
        console.log('转换好src', audio);
      });
      return p.innerHTML;
    },
    deposeImg(html) {
      if (!html) return html;
      let p = this.normalWindow.document.createElement('p');
      p.innerHTML = html;
      let imgs = p.querySelectorAll('img');
      imgs.forEach((e) => {
        e.style.maxWidth = '100%';
      });
      return p.innerHTML;
    },
    setInitailContent() {
      // 如果是新媒体稿
      if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        this.initialContent = this.normalInstance.getContent();
      }
      // 如果是 电视稿
      else if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        this.initialContent = { ...this.tvText };
      }
      // 如果是广播稿
      else if (this.selectedType.id == 2) {
        this.initialContent = this.radioText;
      }
    },
    /**
     * 检查内容变化
     * notEmpty 是否要求内容不为空
     */
    checkInitailContentChange(notEmpty) {
      let changed = false;
      // 如果是新媒体稿
      if (this.selectedType.id == 0 || this.selectedType.id == 3) {
        // 额外判断 智能写稿 保持选区会在外面加 span标签。校验
        changed = this.initialContent != this.deposeOptimizeHightlight(this.normalContent);
        if (notEmpty) {
          changed = changed && !!this.normalContent;
        }
      }
      // 如果是 电视稿
      else if (this.selectedType.id == 1 || this.selectedType.id == 4) {
        changed = JSON.stringify(this.initialContent) != JSON.stringify(this.tvText);
        if (notEmpty) {
          changed = changed && (!!this.tvText.body || !!this.tvText.lead || !!this.tvText.after);
        }
      }
      // 如果是广播稿
      else if (this.selectedType.id == 2) {
        changed = this.initialContent != this.radioText;
        if (notEmpty) {
          changed = changed && !!this.radioText;
        }
      }
      return changed;
    },

    init() {
      console.log('init');
      // 初始化方法
      this.getData().then((r) => {
        console.log('init getData detail', r);
        if (r) {
          console.log('稿件的类型', this.selectedType.id);
          console.log('this.normalContent', this.normalContent);
          // 处理外部导入稿件里的视频 没有controls无法播放问题
          let content = this.deposeVideo(this.normalContent);
          // 处理audio标签的src. 添加iframe.
          content = this.deposeAudioSrc(content);
          content = this.deposeImg(content);
          this.normalInstance.setContent(content);

          // todo 预览1
          this.setInitailContent(content);
          console.log('initialContent', this.initialContent);
          // 适配阿基米德,在刷新和关闭页面清洗并保存
          this.isDraft = r.status == 0;
          if (this.isNew) {
            // 只在新建的情况下开启关联线索后保存
            this.saveAfterCopyclues = r.is_delete == 0;
          }
          // todo 要恢复的
          this.setAutosave();

          if (!this.isNew) {
            if (!r.is_lock) {
              this.lock.interval =
                this.lock.interval ||
                setInterval(() => {
                  this.handleLock();
                }, this.lock.time);
            } else {
              this.lock.locker = r.lock_user_name;
              this.lock.show = true;
            }
          }
        }
      });
    },
    // 适配阿基米德, 关闭或者刷新页面时, 如果平台包括阿基米德 清洗并保存文稿
    registerBeforeUnload() {
      window.addEventListener('beforeunload', this.beforeunload_akmd);
    },
    handleVocieComposeClick() {
      const that = this;
      // 自动保存
      this.handleAutoSave();
      let id = this.$route.query.d;
      if (id) {
        this.$VoiceComposeSelectDialog({
          objId: id,
          objtype: 'publish',
          type: this.$route.query.t,
        }).then((res) => {
          // 选择了系统默认的语音合成
          if (res) {
            that.compositeAudio();
          }
        });
      } else {
        this.$VoiceComposeSelectDialog();
      }
    },
    getAIEditAuth() {
      return common.myFetch(apis.getIntelligentEditAuth, {}).then((r) => {
        if (r) {
          let result = [];
          r.forEach((item) => {
            if (item.is_show) {
              result.push(item.key);
            }
          });
          this.aiEditAuth = result;
          console.log('获取好权限 aiEditAuth', this.aiEditAuth);
        }
      })
    },
    delCover(e) {
      if(this.cover == e){
        this.cover = ''
        this.hasCover = false;
        this.postData('auto')
      }
      console.log('delsrc',e)
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.beforeunload_normal);
    window.removeEventListener('beforeunload', this.beforeunload_akmd);
    if (this.autoSave.interval) {
      clearInterval(this.autoSave.interval);
      this.autoSave.interval = null;
    }

    if (this.lock.interval) {
      clearInterval(this.lock.interval);
      this.handleUnlock();
    }
  },
  beforeDestroy() {
    this.AiWriter && this.$AiWriter(true);
    this.AiOptimizeWriter && this.$AiOptimizeWriter(true);
  },
  mounted() {
    // this.showAiWriter();
    // this.showOptimizeDialog();
    let isRadio = false;
    let domin = window.document.domain;
    if (domin.indexOf('radio') != -1) {
      isRadio = true;
    } else if (domin.indexOf('localhost') != -1) {
      isRadio = false;
    } else {
      isRadio = false;
    }
    this.isRadio = isRadio;
    this.defaultImg = this.$_syscfg.default_img;
    this.calculateWidth();
    window.addEventListener('resize', () => {
      this.calculateWidth();
    });
  },
};
</script>

<style
  src="@assets/css/mediaDetails/mediaCreat.less"
  lang="less"
  scoped
>
</style>
<style lang="less" scoped>
.editor—wrap-outer {
  display: flex;
  .editor-inner {
    flex: 1;
  }
}
li.must.title .title_editor {
  width: 100%;
  font-size: 24px;
  background: none;
  border-bottom: 1px solid #dcdcdc;
  padding: 5px 50px 5px 0;
  outline: none;
  color: #000;
  -webkit-user-modify: read-write-plaintext-only;
  -moz-user-modify: read-write-plaintext-only;
  &.empty::before {
    content: '输入标题';
    color: #b9c3c3;
  }
}
#normalWrapper {
  position: relative;
}
.loadingWithContent-wrapper {
  position: absolute;
  background: rgba(white, 0.9);
  top: 0;
  right: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.loadingWithContent {
  position: fixed;
  top: 50%;
  left: calc(80px + (100vw - 523px) / 2);
  transform: translate(-50%, -50%);
  overflow: visible;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  background-color: rgba(65, 180, 140, 0.9);
  border: 1px solid #41b48c;
  img {
    width: 80px;
    height: 80px;
  }
  .title {
    color: white;
    white-space: nowrap;
  }
}
.loadingwrapper {
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(teal, 0.3);
  }
}
.contentType {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  &::before {
    content: '*';
    display: inline-block;
    width: 10px;
    height: 30px;
    font-size: 24px;
    color: #ff555a;
    margin-right: 10px;
    padding-top: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.autoSelector {
  position: relative;
  // min-width: 200px;
  width: 318px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  min-height: 30px;
  outline: none;
  padding: 0px 10px;
  background: none;
  box-sizing: border-box;
  &.on {
    border: 1px solid #41b48c;
    box-sizing: border-box;
  }

  .arrow {
    content: '';
    display: block;
    width: 10px;
    height: 6px;
    position: absolute;
    top: 0px;
    right: 9px;
    bottom: 0px;
    margin: auto;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABGdBTUEAALGPC/xhBQAAAHtJREFUCB1j3HXkyFaG///5Obi5A+2MjF4zIIFD586J/vj6dT0DI+NHJpCi/wwM1t+/fdsPkoCpA7FBYiA5kBpGmACQow3UeZWTi8sRpBikCFmMESSIrhgkhqwI5CSwQpA4imKQANR0mLvhCkFyO48eFWP8928diI3uOQBKTlEqfGTG1AAAAABJRU5ErkJggg==)
      no-repeat;
    background-position: right center;

    &.on {
      transform: rotate(180deg);
    }
  }

  .contentCategory {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    // height: 100%;
    min-height: 30px;

    .selectd {
      margin: 5px 5px 5px 0;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
      border-radius: 4px;
      background-color: rgba(185, 195, 195, 0.2);
      font-size: 14px;
      color: #050f0f;
      display: flex;
      align-items: center;
      justify-content: space-between;
      white-space: nowrap;
      flex: none;

      img {
        margin-left: 5px;
        cursor: pointer;
      }
    }

    input {
      flex: 1;
      background: transparent;
      height: 30px;

      &::placeholder {
        color: #b9c3c3;
      }
    }
  }

  .selections {
    position: absolute;
    left: 0;
    width: 100%;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 4px;
    overflow: hidden;
    z-index: 9999999;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    max-height: 300px;
    overflow-y: auto;
    .opt {
      width: 100%;
      min-height: 30px;
      font-size: 14px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #050f0f;
      &.on {
        background: rgba(65, 180, 140, 0.15);
      }
      &:hover {
        background: rgba(65, 180, 140, 0.15);
      }
    }
  }

  .selections1 {
    position: absolute;
    left: 316px;
    width: 100%;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 4px;
    overflow: hidden;
    z-index: 9999999;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    max-height: 300px;
    overflow-y: auto;
    border-left: 1px solid #dcdcdc;
    box-sizing: border-box;

    .opt {
      width: 100%;
      min-height: 30px;
      font-size: 14px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #050f0f;
      &.on {
        background: rgba(65, 180, 140, 0.15);
      }
      &:hover {
        background: rgba(65, 180, 140, 0.15);
      }
    }
  }

  .mx-datepicker {
    min-width: 200px !important;
  }
}

.xkleft-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.datePicker {
  display: flex;
  flex-direction: row;
  align-items: center;

  &::before {
    content: '*';
    display: inline-block;
    width: 10px;
    height: 30px;
    font-size: 24px;
    color: #ff555a;
    margin-right: 10px;
    padding-top: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.xkgcRadio {
  display: flex;
  flex-direction: row;
  align-items: center;

  &::before {
    content: '*';
    display: inline-block;
    width: 10px;
    height: 30px;
    font-size: 24px;
    color: #ff555a;
    margin-right: 10px;
    padding-top: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  & > div {
    display: flex;
    flex-direction: row;

    & > p {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 42px;
      user-select: none;
      cursor: pointer;

      &:nth-last-of-type(1) {
        margin: 0;
      }

      &.on {
        i {
          position: relative;
          border: 1px solid #41b48c;
          box-sizing: border-box;

          &:after {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -4.5px;
            margin-left: -4.5px;
            display: block;
            content: '';
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: #41b48c;
          }
        }

        span {
          color: #41b48c;
        }
      }

      i {
        display: block;
        width: 13px;
        height: 13px;
        border: 1px solid #dcdcdc;
        box-sizing: border-box;
        border-radius: 50%;
        margin-right: 12px;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        color: #b9c3c3;
        letter-spacing: 2px;
      }
    }
  }
}
.padding18 {
  padding: 17px 0 !important;
  box-sizing: border-box;
}
.padding18Bottom {
  padding: 17px 0 !important;
  border-bottom: 1px solid #dcdcdc;
  box-sizing: border-box;
}

.ai-btn-conatiner {
  position: sticky;
  bottom: 170px;
  right: 0px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: auto;
  margin-left: auto;
  width: fit-content;

  .ai-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .ai-btn:hover {
    background: #41b48c;
  }

  .ai-btn .voiceCompose {
    width: 20px;
    height: 20px;
    background: url('../../assets/img/common/voiceComposeOn.png') no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  .ai-btn .aiWrite {
    width: 20px;
    height: 20px;
    background: url('../../assets/img/common/aiWrite.png') no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  .ai-btn .aiAudit {
    width: 20px;
    height: 20px;
    background: url('../../assets/img/common/aiAudit.png') no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }
}
</style>
<style lang="less">
.xkgcDatepicker {
  min-width: 200px !important;

  .mx-input {
    min-width: 200px !important;
  }
}
</style>

<style lang="less" scoped>
// todo
#optimizeButton {
  display: none;
  margin-top: 5px;
}

#popup {
  display: none;
  position: absolute;
  background-color: white;
  border: 1px solid black;
  padding: 10px;
  z-index: 1000;
}
.highlight {
  background: rgba(65, 180, 140, 0.15);
}
/* 修改选区的背景色 */
::selection {
  background: rgba(65, 180, 140, 0.15);
}

/* 针对较旧版本的WebKit浏览器（如Safari） */
::-moz-selection {
  /* Firefox专用 */
  background: rgba(65, 180, 140, 0.15);
}
</style>